// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T17:24:31.055Z
// Property: Ascent at Fitzsimons (ID: 6767906449167487)
// Collections: 13 amenities, 11 floorplans (live), 14 photos, 75 POIs, 3 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449167487",
  "property_external_id": "w9p0y0k",
  "property_zillow_url": "https://www.zillow.com/apartments/aurora-co/ascent-at-fitzsimons/5XqVFr/",
  "property_apartments_url": "https://www.apartments.com/ascent-at-fitzsimons-aurora-co/w9p0y0k/",
  "property_google_business_url": "https://www.google.com/maps/place/Ascent+at+Fitzsimons+Apartments/data=!4m2!3m1!1s0x0:0x7f6597a487995af2?sa=X&ved=2ahUKEwj73q_nsemUAxWx3skDHelXOgQQ_BJ6BAgLEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "54896201129",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "ascent-at-fitzsimons",
  "property_name": "Ascent at Fitzsimons",
  "property_website_url": "https://www.ascentfitzsimons.com/",
  "property_domain": "https://www.ascentfitzsimons.com/",
  "property_address": "1678 Paris St",
  "property_full_address": "1678 Paris St, Aurora, CO 80010",
  "property_address_1": "1678 Paris St",
  "property_address_2": null,
  "property_address_city": "Aurora",
  "property_address_state": "CO",
  "property_address_zip_full": null,
  "property_address_zip": "80010",
  "property_address_country": "US",
  "property_address_county": "Adams County",
  "property_neighborhood_address": "North Aurora Division",
  "property_address_latitude": "39.7431011",
  "property_address_longitude": "-104.8478992",
  "property_email": "ascentatfitzsimmons@liveamc.com",
  "property_phone": "(719) 419-8964",
  "property_call_tracking_phone": "7208829120",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": "Apartments.",
  "property_short_description": "Embrace elevated living at Ascent at Fitzsimmons in Aurora, CO. Choose from stylish studio or one-bedroom floor plans, each adorned with natural light, upscale finishes, and private balconies. Enjoy our renovated clubhouse, playground, BBQ picnic area, and proximity to Fitzsimmons Medical Campus. Find your new home today—schedule a tour!",
  "property_long_description": "Ascent at Fitzsimons boasts a pristine location in the tree-lined streets of Aurora. Surrounded by nature, but connected to every amenity imaginable including parks, restaurants, and even the Anschutz Medical Center within walking distance, you have everything you need to make yourself at home. With 148 units of studio, one, two, and three-bedroom apartments, Ascent at Fitzsimons is the right option for just about any size of household! The apartments are fully renovated with upgraded vinyl flooring, granite countertops, shaker style cabinets, framed bathroom mirrors, and more! Inside your home or enjoying the community, you’ll fit right in. **We reserve the right to change pricing at any time and for any reason. Pictures shown might not depict actual units available.**",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184a-5685-7229-8eda-fd06c30343a8.webp",
  "property_featured_image_media": {
    "alt_text": "Courtyard view of a multi-story apartment building with blue and white balconies and exterior staircases.",
    "public_id": "019e184a-5685-7229-8eda-fd06c30343a8",
    "storage_key": "property/6767906449167487/019e184a-5685-7229-8eda-fd06c30343a8.webp",
    "width": 1800,
    "height": 1200
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "149",
  "property_year_built": "1964",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "84.56375838926175",
  "property_admin_fee": "200",
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-1000",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "40",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum 2 pets per unit (cats and dogs allowed)",
  "property_pet_policy_description": "Pets allowed: cats and dogs. Pet deposit: $200. Monthly pet rent: $40. Maximum 2 pets per unit. Non‑refundable pet charge: $200.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://ascentatfitzsimons.goprisma.com/auth/login",
  "property_apply_now_url": "https://myrentalapplication.com/index/amcascentatfitzsimons",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-ff15-71bd-8731-ce5fe6503119.webp",
  "property_primary_logo_media": {
    "alt_text": "Ascent at Fitzsimmons logo",
    "public_id": "019e1849-ff15-71bd-8731-ce5fe6503119",
    "storage_key": "property/6767906449167487/019e1849-ff15-71bd-8731-ce5fe6503119.webp",
    "width": 1243,
    "height": 901
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184a-99d7-74ad-b611-7fdd59068c46.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e184a-99d7-74ad-b611-7fdd59068c46",
    "storage_key": "property/6767906449167487/019e184a-99d7-74ad-b611-7fdd59068c46.webp",
    "width": 1243,
    "height": 901
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184a-8f14-7481-858c-56a477ff26a2.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e184a-8f14-7481-858c-56a477ff26a2",
    "storage_key": "property/6767906449167487/019e184a-8f14-7481-858c-56a477ff26a2.webp",
    "width": 1243,
    "height": 901
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#636577",
  "property_secondary_color": "#5D7399",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "Studio - 2",
  "property_bedrooms_min": "Studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "395 - 10,951,129 sq ft",
  "property_sqft_min": "395",
  "property_sqft_max": "1129",
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": 23,
  "property_facebook_url": "https://www.facebook.com/AscentFitzsimons",
  "property_instagram_url": "https://www.instagram.com/ascent.fitzsimons/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzyYOD7N8bIcR8lqZh6SXZX8",
  "property_youtube_url": "https://www.youtube.com/watch?v=OxzLIMGWBr8",
  "property_yelp_url": "https://www.yelp.com/biz/park-at-fitzsimons-apartments-aurora-3",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Ascent at Fitzsimmons",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Home",
  "property_home_amenities_blurb": "At Ascent at Fitzsimmons in Aurora, CO, vibrant living meets modern comfort. Enjoy sun-drenched spaces, stylish granite countertops, and private balconies alongside a revitalized clubhouse and inviting BBQ picnic areas. Perfectly situated next to the Fitzsimmons Medical Campus, our community offers the ideal balance of convenience and lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Ascent at Fitzsimmons, where modern living meets unmatched comfort in vibrant Aurora, CO. Choose from sleek studios to spacious one-bedroom apartments designed for your lifestyle. Embrace the perfect blend of style and convenience—browse our available homes today and step into a life you’ll love!",
  "property_home_gallery_blurb": "At Ascent at Fitzsimmons in Aurora, CO, picture your new home bathed in natural light with modern finishes like granite countertops and shaker style cabinets. Enjoy community amenities such as a playground, BBQ picnic area, and a beautifully renovated clubhouse, all just steps from Fitzsimmons Medical Campus. Welcome home!",
  "property_home_neighborhood_blurb": "Welcome to Ascent at Fitzsimmons, where vibrant living meets endless adventure! Nestled in Aurora, CO, you'll find local gems like the Denver Zoo, the Denver Museum of Nature & Science, and the serenity of the Denver Botanic Gardens just moments away. Experience a community that truly connects you to the best of the area!",
  "property_home_reviews_blurb": "At Ascent at Fitzsimmons in Aurora, CO, residents rave about the vibrant community spirit, noting it as “a warm and welcoming place to call home.” Experience the perfect blend of modern living and comfort. Dive into our reviews to see what makes our apartments truly special!",
  "property_neighborhood_blurb": "Nestled in vibrant Aurora, Ascent at Fitzsimmons offers more than just stylish studio and one-bedroom floor plans. Enjoy the nearby Denver Zoo, the expansive Denver Museum of Nature & Science, and the lush grounds of the Denver Botanic Gardens. Experience the perfect blend of urban convenience and recreational escapes—your next adventure awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Ascent at Fitzsimmons in Aurora, CO, find the perfect blend of comfort and convenience. Enjoy sunlit living spaces with gourmet kitchens, private balconies, and a vibrant community featuring a playground and BBQ picnic area. Experience a lifestyle enhanced by our renovated clubhouse and professional management, just steps from Fitzsimmons Medical Campus.",
  "property_applynow_blurb": "At Ascent at Fitzsimmons in Aurora, CO, experience stylish living with inviting studio and one-bedroom floor plans. Enjoy our renovated clubhouse, on-site parking, and private balconies. With a prime location next to Fitzsimmons Medical Campus and top-notch amenities, your perfect home awaits. Lease online today for your future oasis!",
  "property_contactus_blurb": "At Ascent at Fitzsimmons in Aurora, CO, choose from stylish studio and one-bedroom floor plans that cater to your lifestyle. Your perfect home awaits in a vibrant community designed for comfort and convenience. Have questions? Contact our leasing team today to learn more about making Ascent your new home!",
  "property_faqs_blurb": "At Ascent at Fitzsimmons in Aurora, CO, choose from stylish studio and one-bedroom floor plans designed for your comfort. Have questions? Our FAQs page is your go-to resource for insights about life in our vibrant community. Dive into the details and elevate your living experience today!",
  "property_floorplans_blurb": "At Ascent at Fitzsimmons in Aurora, CO, your ideal living space awaits. Choose from chic studios or spacious one-bedroom apartments, each thoughtfully designed to elevate your lifestyle. Elevate your experience—browse our available apartment homes today and envision your perfect floor plan!",
  "property_gallery_blurb": "At Ascent at Fitzsimmons in Aurora, CO, envision life in our vibrant community. Choose from inviting studio or one-bedroom layouts, complete with modern finishes like granite countertops and vinyl flooring. Enjoy ample natural light, private balconies, and a host of amenities including a playground and BBQ area. Picture yourself living here!",
  "property_interactivemap_blurb": "At Ascent at Fitzsimmons in Aurora, CO, choose from stylish studio and one-bedroom floor plans tailored for your lifestyle. Revel in abundant natural light, modern amenities, and welcoming community spaces, including a newly renovated clubhouse and BBQ picnic area. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Ascent at Fitzsimmons in Aurora, CO, your furry friends are cherished. With a spacious environment, you and up to two pets can enjoy a vibrant lifestyle. A $200 deposit and $40 monthly fee ensure your pets fit comfortably into our community. Experience pet-friendly living amidst modern comforts!",
  "property_referafriend_blurb": "At Ascent at Fitzsimmons in Aurora, CO, great friends make great neighbors. With chic studio and one-bedroom floor plans, our community offers the perfect blend of comfort and style. Share the experience—refer a friend today and let them enjoy life at Ascent where every moment feels like home!",
  "property_residentaccess_blurb": "At Ascent at Fitzsimmons in Aurora, CO, your ideal living space awaits! Choose from thoughtfully designed studio and one-bedroom floor plans tailored to your lifestyle. Already a resident? Access your portal to manage rent payments, request maintenance, and enjoy convenient living at your fingertips! Your comfort is just a click away.",
  "property_reviews_blurb": "At Ascent at Fitzsimmons in Aurora, CO, residents rave about the vibrant community atmosphere and top-notch amenities. One satisfied resident shares, “Living here feels like home!” Uncover the stories of our happy community and see what makes Ascent at Fitzsimmons the perfect place to call home!",
  "property_created_at": "1778523912284",
  "property_scheduletour_blurb": "At Ascent at Fitzsimmons in Aurora, CO, you’ll find thoughtfully designed studio and one-bedroom apartments that elevate your living experience. With stunning views and modern amenities, each space is a sanctuary. Don’t just take our word for it—check out what our residents love about their vibrant community! Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Ascent at Fitzsimmons in Aurora, CO! Whether you’re dreaming of a cozy studio or a spacious one-bedroom retreat, our diverse floor plans are designed to elevate your lifestyle. A team member will connect with you soon to discuss your ideal home!",
  "property_virtualtours_blurb": "At Ascent at Fitzsimmons in Aurora, CO, a lifestyle of comfort awaits. Choose from our thoughtfully designed studio and one-bedroom floor plans tailored to your needs. Experience the charm of our vibrant community—take a virtual tour today and envision your new home!",
  "property_copyright": "2026 All Rights Reserved. Ascent at Fitzsimmons",
  "property_seo_title_home": "Ascent at Fitzsimmons |  Apartments in Aurora, CO",
  "property_seo_description_home": "Experience modern living at Ascent at Fitzsimmons in Aurora, CO. Enjoy spacious studios, serene balconies, and top-notch amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Aurora, CO Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Ascent at Fitzsimmons! Browse our diverse floor plans, from studios to one-bedrooms, and find your ideal apartment in Aurora, CO.",
  "property_seo_title_amenities": "Amenities | Aurora, CO Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Ascent at Fitzsimmons with spacious floor plans, a renovated clubhouse, and sunny balconies near Fitzsimmons Medical Campus!",
  "property_seo_title_gallery": "Gallery | Apartments in Aurora, CO",
  "property_seo_description_gallery": "Picture life at Ascent at Fitzsimmons in Aurora, CO! Enjoy stunning studio and one-bedroom homes with modern amenities, natural light, and a vibrant community.",
  "property_seo_title_virtualtours": "Virtual Tours | Ascent at Fitzsimmons Apartments",
  "property_seo_description_virtualtours": "Experience luxury living at Ascent at Fitzsimmons in Aurora, CO. Take a virtual tour of our stylish studio and one-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Ascent at Fitzsimmons Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Ascent at Fitzsimmons! Enjoy spacious plans, modern amenities, and a vibrant community near Fitzsimmons Medical Campus!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Aurora, CO",
  "property_seo_description_neighborhood": "Uncover Aurora's hidden gems around Ascent at Fitzsimmons. Enjoy vibrant local favorites and top attractions just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Ascent at Fitzsimmons",
  "property_seo_description_contact": "Elevate your lifestyle at Ascent at Fitzsimmons in Aurora, CO. Explore our studio and one-bedroom floor plans. Questions? Our leasing team is ready to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Aurora, CO",
  "property_seo_description_faqs": "Find answers about life at Ascent at Fitzsimmons in Aurora, CO. From stylish floor plans to top-notch amenities, we’ve got your questions covered!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Aurora, CO",
  "property_seo_description_reviews": "Join our vibrant community at Ascent at Fitzsimmons in Aurora, CO. Discover resident experiences and see why our beautiful apartments feel like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Aurora, CO",
  "property_seo_description_applynow": "Discover your ideal home at Ascent at Fitzsimmons, Aurora, CO! Enjoy renovated amenities, private balconies, and a prime location near Fitzsimmons Medical Campus.",
  "property_seo_title_residentaccess": "Resident Access | Ascent at Fitzsimmons",
  "property_seo_description_residentaccess": "Elevate your living experience at Ascent at Fitzsimmons! Log in to your resident portal to manage rent, maintenance, and enjoy your community seamlessly.",
  "property_seo_title_referafriend": "Refer A Friend | Ascent at Fitzsimmons",
  "property_seo_description_referafriend": "Refer a friend to Ascent at Fitzsimmons in Aurora, CO! Enjoy vibrant living together and create lasting memories in a community you’ll both love.",
  "property_seo_title_scheduletour": "Schedule a Tour | Ascent at Fitzsimmons",
  "property_seo_description_scheduletour": "Experience modern living at Ascent at Fitzsimmons in Aurora, CO. Schedule your tour today and envision your new home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Ascent at Fitzsimmons",
  "property_seo_description_privacy": "Your data security is our priority. Read the Ascent at Fitzsimmons Privacy Policy to see how we protect your information in Aurora.",
  "property_seo_title_accessibility": "Website Accessibility | Ascent at Fitzsimmons",
  "property_seo_description_accessibility": "At Ascent at Fitzsimmons in Aurora, CO, we prioritize digital inclusion, ensuring all residents access online services. Join our community today!",
  "property_seo_title_sitemap": "Sitemap | Ascent at Fitzsimmons",
  "property_seo_description_sitemap": "Navigate your way to your dream home at Ascent at Fitzsimmons in Aurora, CO. Check out our sitemap to explore layouts and amenities tailored for you!",
  "property_seo_title_thankyou": "Thank You | Ascent at Fitzsimmons",
  "property_seo_description_thankyou": "Thank you for reaching out to Ascent at Fitzsimmons! Your info is with us, and our team will connect soon. Exciting living in Aurora awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Aurora, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786638717720",
  "amenities": [
    {
      "id": "custom_4ad86bea-aa86-46f2-8e57-328cb2afb00d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_064e631a-16ea-44ca-bac7-4d2942d32f4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Picnic Area",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_38864d7e-c2e2-4fda-afb3-2c77fc511e6a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Clubhouse/Leasing Office",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c50b856a-feca-4050-9643-73c83e9caa76",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Parking",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c55c4bd7-e742-4296-98bf-176e41677dac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Professional Management",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af38d7a3-0f68-43bc-8469-78b6a3311828",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Amazing Location Next Door to Fitzsimmons Medical Campus",
      "amount": "false",
      "description": "Exists under Community Amenities on the official amenities page.",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e92e8b93-9199-4af7-8025-d16d68ef744a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balconies & Patios*",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f428221d-de84-4a7f-bf6e-25c889e89e57",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Lots of Natural Lighting",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5dfdf769-0af6-480f-b3bf-ea5fb9bf1897",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Window A/C Units",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_23ed5678-a959-4345-ab44-95f8eac848b5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "New Appliances",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cd738ba4-257e-491a-b132-0256b2004c1f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b140abe0-46e6-4b18-8f46-28fd6d9ec4f7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops in Select Units",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1992090-d1bb-4b38-9cfc-39a4873e5572",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "external_id": "false",
      "title": "Shaker Style Cabinets",
      "amount": "false",
      "description": "Exists under Apartment Amenities on the official amenities page.",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7456ee3c-fb0d-481b-9da6-6101188bd728",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4c-4441-7119-9690-260f4b8c5230.webp",
      "image_media": {
        "alt_text": "Exterior view of a grey multifamily apartment building with balconies and large windows under a cloudy sky.",
        "public_id": "019f5f4c-4441-7119-9690-260f4b8c5230",
        "storage_key": "property/6767906449167487/019f5f4c-4441-7119-9690-260f4b8c5230.webp",
        "width": 850,
        "height": 567
      },
      "title": "Community",
      "description": "A view of the exterior of a multifamily apartment building, showcasing its modern design with balconies and expansive windows.",
      "link": "",
      "alt_text": "Exterior view of a grey multifamily apartment building with balconies and large windows under a cloudy sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2bd1aa6f-73d7-4fd6-876f-256df55bf6e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4c-31ee-7288-890c-033f44ec1092.webp",
      "image_media": {
        "alt_text": "Modern leasing office with reception desk, seating areas, and large windows.",
        "public_id": "019f5f4c-31ee-7288-890c-033f44ec1092",
        "storage_key": "property/6767906449167487/019f5f4c-31ee-7288-890c-033f44ec1092.webp",
        "width": 1536,
        "height": 1057
      },
      "title": "Community",
      "description": "Welcome to our leasing office, a modern and inviting space with comfortable seating and a professional reception area.",
      "link": "",
      "alt_text": "Modern leasing office with reception desk, seating areas, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c06fef5b-42ed-4560-ae2c-8406eae850dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4c-2ec8-753d-8463-4a88042e9aca.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with seating, kitchenette, and large window.",
        "public_id": "019f5f4c-2ec8-753d-8463-4a88042e9aca",
        "storage_key": "property/6767906449167487/019f5f4c-2ec8-753d-8463-4a88042e9aca.webp",
        "width": 1536,
        "height": 997
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring a modern kitchenette, comfortable seating, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Modern community lounge area with seating, kitchenette, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7dc07b06-afd1-476f-a42e-835cffd65343",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4c-2503-74cc-bc43-a156aabe15f2.webp",
      "image_media": {
        "alt_text": "Spacious common area with seating, large windows, and modern lighting.",
        "public_id": "019f5f4c-2503-74cc-bc43-a156aabe15f2",
        "storage_key": "property/6767906449167487/019f5f4c-2503-74cc-bc43-a156aabe15f2.webp",
        "width": 1536,
        "height": 850
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish common area, featuring comfortable seating and abundant natural light. A perfect space to unwind or connect with neighbors.",
      "link": "",
      "alt_text": "Spacious common area with seating, large windows, and modern lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2773f815-9ac5-41f8-872c-23ff356464e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4b-f81b-74f8-900d-fe66ad1a3f62.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and a breakfast bar.",
        "public_id": "019f5f4b-f81b-74f8-900d-fe66ad1a3f62",
        "storage_key": "property/6767906449167487/019f5f4b-f81b-74f8-900d-fe66ad1a3f62.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring white cabinetry, granite countertops, and a convenient breakfast bar. Perfect for a quick meal or entertaining guests.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_08c23ce9-9616-4ace-a5d8-ae77710832fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4b-f570-704e-b3ef-ae3eb696d0d6.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV stand.",
        "public_id": "019f5f4b-f570-704e-b3ef-ae3eb696d0d6",
        "storage_key": "property/6767906449167487/019f5f4b-f570-704e-b3ef-ae3eb696d0d6.webp",
        "width": 850,
        "height": 567
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable sectional sofa, modern coffee table, and entertainment center, perfect for relaxation and gatherings.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6eba3ed5-d6d6-4ede-ab0c-237bae2c261d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019f5f4b-f56f-76d9-bb5f-1a73ce53582c.webp",
      "image_media": {
        "alt_text": "A king-sized bed in a well-lit bedroom with a blue armchair and a nightstand.",
        "public_id": "019f5f4b-f56f-76d9-bb5f-1a73ce53582c",
        "storage_key": "property/6767906449167487/019f5f4b-f56f-76d9-bb5f-1a73ce53582c.webp",
        "width": 850,
        "height": 567
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, elegant nightstand, and a cozy armchair, perfect for relaxation.",
      "link": "",
      "alt_text": "A king-sized bed in a well-lit bedroom with a blue armchair and a nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7a755b41-974b-419e-931c-9a1fe5eac0b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e5375-7079-7168-9d19-badf524194dd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, black appliances, granite countertops, and stainless steel sink.",
        "public_id": "019e5375-7079-7168-9d19-badf524194dd",
        "storage_key": "property/6767906449167487/019e5375-7079-7168-9d19-badf524194dd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring white cabinetry, sleek granite countertops, a full suite of black appliances including a refrigerator, dishwasher, microwave, and stove, and a modern stainless steel sink.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, black appliances, granite countertops, and stainless steel sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fe2fd3d-8180-4926-94dd-6c139352d0e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184c-53fe-73cb-8587-baf5653d3a9f.webp",
      "image_media": {
        "alt_text": "Spacious living room with a large sectional sofa, coffee table, and TV stand.",
        "public_id": "019e184c-53fe-73cb-8587-baf5653d3a9f",
        "storage_key": "property/6767906449167487/019e184c-53fe-73cb-8587-baf5653d3a9f.webp",
        "width": 850,
        "height": 567
      },
      "title": "Apartment",
      "description": "Enjoy this beautifully furnished living room, perfect for relaxing or entertaining guests. Features a comfortable sectional sofa, modern coffee table, and elegant decor.",
      "link": "",
      "alt_text": "Spacious living room with a large sectional sofa, coffee table, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae08022f-eb41-4b4d-a09d-8f1f5b3e7091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184c-5254-7410-93f8-2f94935ebf2f.webp",
      "image_media": {
        "alt_text": "A beautifully staged bedroom with a king-size bed, a blue accent chair, and large windows.",
        "public_id": "019e184c-5254-7410-93f8-2f94935ebf2f",
        "storage_key": "property/6767906449167487/019e184c-5254-7410-93f8-2f94935ebf2f.webp",
        "width": 850,
        "height": 567
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this elegantly furnished bedroom, featuring a plush king-size bed and a cozy seating area. Perfect for relaxation and unwinding after a long day.",
      "link": "",
      "alt_text": "A beautifully staged bedroom with a king-size bed, a blue accent chair, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_602ea880-57d2-447c-bbc5-06298cd617a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184b-0268-7068-94ce-8cad7333ad53.webp",
      "image_media": {
        "alt_text": "Playground with slides in a courtyard of an apartment building.",
        "public_id": "019e184b-0268-7068-94ce-8cad7333ad53",
        "storage_key": "property/6767906449167487/019e184b-0268-7068-94ce-8cad7333ad53.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the on-site playground, a fun area for children to play and explore within the community's central courtyard.",
      "link": "",
      "alt_text": "Playground with slides in a courtyard of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d09a720f-7315-4de3-86c4-3ad0e40612de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184b-00fe-74f4-ad89-614e9990f088.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and living area with dining table, black refrigerator, and TV.",
        "public_id": "019e184b-00fe-74f4-ad89-614e9990f088",
        "storage_key": "property/6767906449167487/019e184b-00fe-74f4-ad89-614e9990f088.webp",
        "width": 850,
        "height": 567
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment living area featuring an open-plan kitchen, dining space, and lounge area with a TV.",
      "link": "",
      "alt_text": "Modern apartment kitchen and living area with dining table, black refrigerator, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2436f6a0-6331-481c-8be9-fe8d2c0845ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184a-5bb4-7459-923e-86352e215b80.webp",
      "image_media": {
        "alt_text": "Courtyard with a playground and picnic area",
        "public_id": "019e184a-5bb4-7459-923e-86352e215b80",
        "storage_key": "property/6767906449167487/019e184a-5bb4-7459-923e-86352e215b80.webp",
        "width": 1800,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our community courtyard, complete with a playground for kids and a covered picnic area for gatherings.",
      "link": "",
      "alt_text": "Courtyard with a playground and picnic area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_894c7967-68ac-4aae-995c-3c3005bd63eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184a-4f3e-728e-b9c4-f3a1adf8fd47.webp",
      "image_media": {
        "alt_text": "Community lounge area with seating and reception desk.",
        "public_id": "019e184a-4f3e-728e-b9c4-f3a1adf8fd47",
        "storage_key": "property/6767906449167487/019e184a-4f3e-728e-b9c4-f3a1adf8fd47.webp",
        "width": 2560,
        "height": 1761
      },
      "title": "Community",
      "description": "Spacious and modern community lounge area featuring a reception desk, comfortable seating, and large windows offering natural light.",
      "link": "",
      "alt_text": "Community lounge area with seating and reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9c4fbc13-0990-4b24-b463-2c9a8cd43373",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "14150 E Alameda Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "Reviewers consistently praise this burger joint for its delicious, fresh, and hot burgers, with the \"animal style\" option being a popular recommendation. Customers also appreciate the affordable prices and the consistently clean environment.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-4b50-75b4-ae94-4c0a6934fabd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-4b50-75b4-ae94-4c0a6934fabd",
        "storage_key": "property/6767906449167487/019e1849-4b50-75b4-ae94-4c0a6934fabd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.in-n-out.com/360",
      "poi_directions_map_url": "https://maps.google.com/?cid=14828867425962304576&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "39.7107311",
      "poi_longitude": "-104.8236298",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXeOanAdjbIcRQCTYcVu4ys0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_b2e6d2eb-5d15-4386-90c2-8e8b7ffeceac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Culinary Dropout",
      "poi_type": "Restaurants",
      "poi_address": "4141 E 9th Ave, Denver, CO 80220, USA",
      "poi_short_description": "Cool, British-style gastropub chain with quirky decor, serving inventive cocktails & comfort food.",
      "poi_long_description": "Diners praise the delicious food at this restaurant, with popular choices including the fried chicken, crispy chicken katsu sandwich, and flavorful ribs. The lively atmosphere and dog-friendly patio are also frequently highlighted by patrons.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-53a3-742b-9717-2d0717056137.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-53a3-742b-9717-2d0717056137",
        "storage_key": "property/6767906449167487/019e1849-53a3-742b-9717-2d0717056137.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.culinarydropout.com/locations/denver-co/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4763160578933938133&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "culinary-dropout",
      "poi_latitude": "39.7311775",
      "poi_longitude": "-104.9390615",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 720-779-0190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31UE2n1_bIcR1VeAa08lGkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_e7466fb5-6cf3-4952-b48d-8032f29d6a0a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Atomic Cowboy home of Denver Biscuit Co & Fat Sully's NY Pizza",
      "poi_type": "Restaurants",
      "poi_address": "3237 E Colfax Ave, Denver, CO 80206, USA",
      "poi_short_description": "Biscuit-based breakfast & sandwich shop set up inside the warehouse-like Atomic Cowboy bar.",
      "poi_long_description": "People say this restaurant serves delicious biscuit sandwiches, pizza, and burgers. They highlight the generous portions, reasonable prices, and fun, laid-back atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-53f7-7514-8662-9bbbc660637f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-53f7-7514-8662-9bbbc660637f",
        "storage_key": "property/6767906449167487/019e1849-53f7-7514-8662-9bbbc660637f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://www.theatomiccowboy.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=6665378868563934674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "atomic-cowboy-home-of-denver-biscuit-co--fat-sullys-ny-pizza",
      "poi_latitude": "39.7403976",
      "poi_longitude": "-104.9490503",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 303-339-3977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB8H2oa1-bIcR0v0lKsQugFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1236228c-a36e-4224-83aa-cb63a6285051",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1190 S Colorado Blvd, Denver, CO 80246, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and the Cane's secret sauce. They also highlight the friendly and efficient service, and the quick and easy drive-thru.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-4f57-7290-8c67-e94d02878b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-4f57-7290-8c67-e94d02878b17",
        "storage_key": "property/6767906449167487/019e1849-4f57-7290-8c67-e94d02878b17.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/co/denver/1190-south-colorado-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=9802964513514154519&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "39.6949914",
      "poi_longitude": "-104.9400417",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 303-758-5012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk4aKdkZ_bIcRF2rFZUkgC4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7046231a-0677-4063-b285-53bbf5cc3330",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Cherry Creek Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "3000 E 1st Ave, Denver, CO 80206, USA",
      "poi_short_description": "",
      "poi_long_description": "Reviewers consistently praise this shopping mall for its extensive selection of both upscale and popular stores, including numerous luxury brands, alongside its helpful staff. Furthermore, they appreciate the convenient paid parking options and the mall's well-maintained atmosphere.\n\nSome reviews mention the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-493d-712f-8b67-aaece4bd847b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-493d-712f-8b67-aaece4bd847b",
        "storage_key": "property/6767906449167487/019e1849-493d-712f-8b67-aaece4bd847b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/cherry-creek-shopping-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=2129569259550066659&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cherry-creek-shopping-center",
      "poi_latitude": "39.7166735",
      "poi_longitude": "-104.9529928",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 303-388-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-8300-719c-85f8-522ad8dd6062.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-8300-719c-85f8-522ad8dd6062",
        "storage_key": "property/6767906449167487/019e1849-8300-719c-85f8-522ad8dd6062.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJX4Jmj5B-bIcR48cSaPW_jR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_df20934e-640c-477f-ad61-1b2c0c66f2c3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "H Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2751 S Parker Rd, Aurora, CO 80014, USA",
      "poi_short_description": "Large supermarket brimming with fresh produce and international foods.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, seafood, and international ingredients, including many hard-to-find items. They also highlight the reasonable prices and the clean, organized layout.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-532f-73b3-b9a4-1bbbdd99aa0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-532f-73b3-b9a4-1bbbdd99aa0e",
        "storage_key": "property/6767906449167487/019e1849-532f-73b3-b9a4-1bbbdd99aa0e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.myhmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9729704830360140207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart",
      "poi_latitude": "39.6659575",
      "poi_longitude": "-104.8632898",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-745-4592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f2-778c-b82b-73bf48e461f6",
        "storage_key": "property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDenuLPKHbIcRr7kEN_7aBoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_195df42c-b55c-4bca-b571-67a984bdb3ed",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Mershops Town Center at Aurora",
      "poi_type": "Shopping & Retail",
      "poi_address": "14200 E Alameda Ave, Aurora, CO 80012, USA",
      "poi_short_description": "Bustling indoor mall featuring 150-plus retailers, including big-box stores, & restaurants.",
      "poi_long_description": "Visitors say this mall offers a wide variety of stores, a great food court with diverse options like Korean corn dogs, and comfortable seating with charging ports. They also highlight the clean restrooms, ample parking, and lively, friendly atmosphere.\n\nSome reviews mention the security can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-501d-772c-8401-95d652822d11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-501d-772c-8401-95d652822d11",
        "storage_key": "property/6767906449167487/019e1849-501d-772c-8401-95d652822d11.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://towncenterataurora.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3680964791751543485&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mershops-town-center-at-aurora",
      "poi_latitude": "39.7082577",
      "poi_longitude": "-104.823209",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-344-9764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-8300-719c-85f8-522ad8dd6062.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-8300-719c-85f8-522ad8dd6062",
        "storage_key": "property/6767906449167487/019e1849-8300-719c-85f8-522ad8dd6062.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaR59v8JibIcRvQoSu_lpFTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4f2297af-4895-4119-9c83-6bc490465d9b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Colorado Blvd, Denver, CO 80206, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of unique products, including snacks, wine, and flowers. They highlight the good prices and low-key, kind atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-4aa8-704e-9d01-f4087090a13c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-4aa8-704e-9d01-f4087090a13c",
        "storage_key": "property/6767906449167487/019e1849-4aa8-704e-9d01-f4087090a13c.webp",
        "width": 1280,
        "height": 859
      },
      "poi_business_url": "https://locations.traderjoes.com/co/denver/300/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1476841973712745415&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "39.7287708",
      "poi_longitude": "-104.9403211",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 303-321-1003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f2-778c-b82b-73bf48e461f6",
        "storage_key": "property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9N7taB-bIcRx_OIUPPLfhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8eac3478-6e9c-4d63-8bd8-1f33e68f670c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2375 E 1st Ave, Denver, CO 80206, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers fresh produce and outstanding value on freshly made pizzas. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the parking can be challenging.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-4bce-749e-a6e0-64bcd9d19d64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-4bce-749e-a6e0-64bcd9d19d64",
        "storage_key": "property/6767906449167487/019e1849-4bce-749e-a6e0-64bcd9d19d64.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/cherrycreek?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=3352427147004831396&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "39.7185829",
      "poi_longitude": "-104.9576861",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 720-941-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f2-778c-b82b-73bf48e461f6",
        "storage_key": "property/6767906449167487/019e1849-82f2-778c-b82b-73bf48e461f6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWflJZR-bIcRpGaZcLo2hi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f57f5a2a-8d03-4d02-ad83-9ceba19d71e3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "University of Colorado Anschutz",
      "poi_type": "Education",
      "poi_address": "13001 E 17th Pl, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5b6d-747c-8081-a0778784f4ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5b6d-747c-8081-a0778784f4ea",
        "storage_key": "property/6767906449167487/019e1849-5b6d-747c-8081-a0778784f4ea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cuanschutz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9364229194661812447&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-colorado-anschutz",
      "poi_latitude": "39.7423236",
      "poi_longitude": "-104.8413468",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 303-724-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGXo4rk5jbIcR39got9Zs9IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bec7db3b-57d2-4f94-9982-2226f0942a8e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Denver Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2300 Steele St, Denver, CO 80205, USA",
      "poi_short_description": "Sprawling facility with animal exhibits, shows & demonstrations, plus venues for eating & shopping.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, giraffes, and lions, with many exhibits providing close-up viewing opportunities. Visitors also highlight the well-maintained grounds and clean facilities, including spotless restrooms. They appreciate the friendly and informative staff, as well as the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5dd6-76eb-ae33-8e5e7f7b1746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5dd6-76eb-ae33-8e5e7f7b1746",
        "storage_key": "property/6767906449167487/019e1849-5dd6-76eb-ae33-8e5e7f7b1746.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://denverzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6052009770394020905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "denver-zoo",
      "poi_latitude": "39.7495961",
      "poi_longitude": "-104.9508519",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 720-337-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcY8lIE55bIcRKWyHPdIO_VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_087d4c3b-804b-4d02-af63-5d8d2258c8df",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Denver Museum of Nature & Science",
      "poi_type": "Entertainment",
      "poi_address": "2001 Colorado Blvd, Denver, CO 80205, USA",
      "poi_short_description": "Movie theater chain known for presenting 3D films on a giant screen, including blockbusters.",
      "poi_long_description": "Visitors say this science museum features impressive dinosaur exhibits, a planetarium, and a children's discovery area with interactive displays. They also highlight the friendly and knowledgeable staff, the clean environment, and the free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5ab8-744d-8584-396b0690ebc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5ab8-744d-8584-396b0690ebc7",
        "storage_key": "property/6767906449167487/019e1849-5ab8-744d-8584-396b0690ebc7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dmns.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14789549545145786897&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "denver-museum-of-nature--science",
      "poi_latitude": "39.7475261",
      "poi_longitude": "-104.9428078",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-370-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f8-772b-a618-9c8d45e9e2a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f8-772b-a618-9c8d45e9e2a1",
        "storage_key": "property/6767906449167487/019e1849-82f8-772b-a618-9c8d45e9e2a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJI3SnU1F5bIcREWJ08vMIP80",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_25348b54-d0d3-497b-8668-642fe3fca977",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Dick’s Sporting Goods Park",
      "poi_type": "Entertainment",
      "poi_address": "6000 Victory Way, Commerce City, CO 80022, USA",
      "poi_short_description": "Sports complex home to the Colorado Rapids soccer team, plus concerts & rentable playing fields.",
      "poi_long_description": "Visitors say this stadium offers great sightlines from virtually every seat, a wide variety of food and drink options, and clean, well-maintained facilities. They also highlight the family-friendly atmosphere, helpful staff, and free parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5721-76ea-8cde-d0a847b91cce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5721-76ea-8cde-d0a847b91cce",
        "storage_key": "property/6767906449167487/019e1849-5721-76ea-8cde-d0a847b91cce.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "http://www.dickssportinggoodspark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12947117968694586269&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dicks-sporting-goods-park",
      "poi_latitude": "39.8055568",
      "poi_longitude": "-104.8916117",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 303-727-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f8-772b-a618-9a6213f240d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f8-772b-a618-9a6213f240d1",
        "storage_key": "property/6767906449167487/019e1849-82f8-772b-a618-9a6213f240d1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo51u-_V6bIcRnSseHTJnrbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9bf667e7-483e-4a47-b74f-d057544b5b8b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Wings Over the Rockies Air & Space Museum",
      "poi_type": "Entertainment",
      "poi_address": "7711 E Academy Blvd, Denver, CO 80230, USA",
      "poi_short_description": "Wartime aircraft, WWII uniform collection & aviation art on the former site of Lowry Air Force Base.",
      "poi_long_description": "Visitors say this museum features an impressive collection of military and civilian aircraft, including rare planes and Star Wars exhibits. They also highlight the knowledgeable and friendly staff, who provide excellent information and stories. Guests mention it's a great place for families, offering interactive exhibits and a dedicated play area for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5abb-734c-ba54-a6073b4765fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5abb-734c-ba54-a6073b4765fb",
        "storage_key": "property/6767906449167487/019e1849-5abb-734c-ba54-a6073b4765fb.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://wingsmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18042612551295927622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wings-over-the-rockies-air--space-museum",
      "poi_latitude": "39.7208907",
      "poi_longitude": "-104.8955075",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-360-5360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82f8-772b-a618-9c8d45e9e2a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82f8-772b-a618-9c8d45e9e2a1",
        "storage_key": "property/6767906449167487/019e1849-82f8-772b-a618-9c8d45e9e2a1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3XERyVl8bIcRRoX_g4U8ZPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c861b13e-3034-4dc0-9e80-09767611deb9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "9550 E 40th Ave, Denver, CO 80238, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this trampoline park offers a huge variety of attractions, including ball pits, a zip line, climbing areas, and trampolines, providing nonstop fun for kids. They also highlight the clean facilities, friendly staff, and the value of monthly memberships.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-5bde-76cf-afc5-53e07e878504.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-5bde-76cf-afc5-53e07e878504",
        "storage_key": "property/6767906449167487/019e1849-5bde-76cf-afc5-53e07e878504.webp",
        "width": 560,
        "height": 314
      },
      "poi_business_url": "https://www.urbanair.com/denver-east-colorado/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=8741669168741948440&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "39.773019",
      "poi_longitude": "-104.8780103",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-536-1951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTdNdHt7bIcRGBzZKsulUHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_8e6dd53e-e39f-40e0-be3d-d64c8f433669",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15200 E Colfax Ave, Aurora, CO 80011, USA",
      "poi_short_description": "Large gym, sporting a pool and a basketball court, that offers group fitness classes, personal training and free weights.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and studio classes, including Studio Red and Studio Lift, with many finding the KidCare program excellent. Visitors also highlight the friendly and helpful staff, especially the morning crew, and appreciate the affordable membership.\n\nSome reviews mention the facility can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-63fc-77db-8fab-47c05af9ffeb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-63fc-77db-8fab-47c05af9ffeb",
        "storage_key": "property/6767906449167487/019e1849-63fc-77db-8fab-47c05af9ffeb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/co/aurora-colfax-chambers/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6216857026923537615&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "39.7384169",
      "poi_longitude": "-104.8110519",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-294-6630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjcDVnCJjbIcRzyQrFYe2RlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_95c82549-652e-474a-9c97-f39a6eddb61f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "779 Peoria St, Aurora, CO 80011, USA",
      "poi_short_description": "Spacious facility with clean showers, a sauna and massage chairs, offering free passes.",
      "poi_long_description": "People say this gym is consistently clean and spacious, offering a wide variety of well-maintained equipment and classes. They also highlight the friendly and welcoming staff, who are often described as helpful and attentive. Guests mention the reasonable membership prices and additional amenities like smoothies, hydromassage, and a cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6004-7571-abab-de46219552ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6004-7571-abab-de46219552ad",
        "storage_key": "property/6767906449167487/019e1849-6004-7571-abab-de46219552ad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/co/aurora/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12241079220323701034&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "39.7279532",
      "poi_longitude": "-104.8481069",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 720-716-2434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBcy-g3F9bIcRKlHP4rEM4ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_9416d39c-fc44-4432-aa9a-b3b6925df554",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "500 S Cherry St, Denver, CO 80246, USA",
      "poi_short_description": "Athletic country club with a basketball court, pools, Pilates studio, and yoga classes, plus a spa.",
      "poi_long_description": "Reviewers consistently praise this gym for its wide variety of modern equipment, including a year-round pool and hot tub, as well as its friendly and helpful staff.\n\nOther reviews mention the facilities can be poorly maintained and overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6037-7366-ad41-e8f048746689.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6037-7366-ad41-e8f048746689",
        "storage_key": "property/6767906449167487/019e1849-6037-7366-ad41-e8f048746689.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/co/cherry-creek.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8107291191987169992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "39.7068537",
      "poi_longitude": "-104.9324267",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 720-572-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5-93OXh9bIcRyGoMhWLignA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_20b6924d-471d-4cbb-80f3-d5f6dc1bbb9e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7600 E Academy Blvd, Denver, CO 80230, USA",
      "poi_short_description": "Fitness center chain offering a range of strength and cardio equipment, lap pools, and fitness classes.",
      "poi_long_description": "People say this gym offers a variety of equipment, classes, and amenities, including a sauna and steam room, and provides a great atmosphere.\n\nOther reviews mention the equipment can be old and the space can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-613d-706b-9b40-bb69a9b2f3ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-613d-706b-9b40-bb69a9b2f3ba",
        "storage_key": "property/6767906449167487/019e1849-613d-706b-9b40-bb69a9b2f3ba.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/denver-co/lowry-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=7986029190120920934&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "39.7189556",
      "poi_longitude": "-104.8963",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-343-1049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fX3RVd8bIcRZtcOkzwT1G4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8cd3fe03-ed72-49db-8a92-e287c4fcda37",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4876 Chambers Rd, Denver, CO 80239, USA",
      "poi_short_description": "Chain venue featuring workout equipment, tanning beds and cardio machines.",
      "poi_long_description": "People say this gym is exceptionally clean with well-maintained, updated equipment, offers a welcoming atmosphere, and has friendly, professional staff.\n\nOther reviews mention the showers can be cold and parking can be difficult for truckers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-626f-70fa-b18b-e82e1e3f3d83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-626f-70fa-b18b-e82e1e3f3d83",
        "storage_key": "property/6767906449167487/019e1849-626f-70fa-b18b-e82e1e3f3d83.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/denver-chambers-rd-co?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11523819329020605312&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.7861841",
      "poi_longitude": "-104.8086592",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 303-373-5992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ32S9EfJkbIcRgLMNup_U7J8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_21812132-1961-4d73-9ec5-14206bca6010",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "VCA Alameda East Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9770 E Alameda Ave, Denver, CO 80247, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-63fb-739b-ab00-bafac562ea03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-63fb-739b-ab00-bafac562ea03",
        "storage_key": "property/6767906449167487/019e1849-63fb-739b-ab00-bafac562ea03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vcahospitals.com/alameda-east?utm_source=maps&utm_medium=organic&utm_campaign=AU_688",
      "poi_directions_map_url": "https://maps.google.com/?cid=16822863409619040702&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vca-alameda-east-veterinary-hospital",
      "poi_latitude": "39.708576",
      "poi_longitude": "-104.874224",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 303-366-2639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc6eZpR59bIcRvnlCwyPRduk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_987a5780-ce47-48a0-9e67-f13305a4251b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Children's Hospital Colorado Anschutz Medical Campus, Aurora",
      "poi_type": "Health and Wellness",
      "poi_address": "13123 E 16th Ave, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-679d-76d2-b18f-7be98b42cd54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-679d-76d2-b18f-7be98b42cd54",
        "storage_key": "property/6767906449167487/019e1849-679d-76d2-b18f-7be98b42cd54.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.childrenscolorado.org/locations/anschutz-medical-campus-aurora/?slid=org_soc&utm_source=google&utm_medium=extlist&utm_campaign=locations&utm_id=chcamc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17832171354029654962&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-hospital-colorado-anschutz-medical-campus-aurora",
      "poi_latitude": "39.7422495",
      "poi_longitude": "-104.8349311",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 720-777-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-4a2894cccc58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-4a2894cccc58",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-4a2894cccc58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxqmx0hjbIcRsoPVGl6ZePc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_1b73a207-f070-4e8b-9a18-dd47e6e45432",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "UCHealth University of Colorado Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12605 E 16th Ave, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6fc9-73d7-a3a2-a59932107c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6fc9-73d7-a3a2-a59932107c57",
        "storage_key": "property/6767906449167487/019e1849-6fc9-73d7-a3a2-a59932107c57.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-university-of-colorado-hospital-uch/",
      "poi_directions_map_url": "https://maps.google.com/?cid=975602612854654780&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uchealth-university-of-colorado-hospital",
      "poi_latitude": "39.7421191",
      "poi_longitude": "-104.8414959",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 720-848-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-4a2894cccc58.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-4a2894cccc58",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-4a2894cccc58.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJDdDNZ7N8bIcRPAclTWgJig0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c24bed2e-0313-4589-a4d3-7bcaaacba4a3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Denver Botanic Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1007 York St, Denver, CO 80206, USA",
      "poi_short_description": "Horticultural library at Denver Botanic Gardens including rare books, seed catalogs & other items.",
      "poi_long_description": "People say this garden offers a beautiful collection of plants and flowers, and a relaxing atmosphere. They highlight the aromatherapy from the flowers and plants, and the opportunity to see hummingbirds. They also like the friendly and knowledgeable staff, and the well-maintained grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-68c4-777c-a6ed-6024436a05d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-68c4-777c-a6ed-6024436a05d3",
        "storage_key": "property/6767906449167487/019e1849-68c4-777c-a6ed-6024436a05d3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.botanicgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4619531906286972442&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "denver-botanic-gardens",
      "poi_latitude": "39.7320964",
      "poi_longitude": "-104.9612839",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 720-865-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0T6BO7h-bIcRGm7RHsvfG0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_810de25f-4f61-4c39-ad0f-84fde88279b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Aurora Sports Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "19300 E Colfax Ave, Aurora, CO 80011, USA",
      "poi_short_description": "A 220-acre park with 12 baseball & 23 multi-use/soccer fields that host competitions at many levels.",
      "poi_long_description": "People say this sports park features well-maintained grass and turf fields for various sports, including soccer, softball, and baseball. They also highlight the clean and convenient restrooms, as well as the ample parking available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-685f-773a-b571-19d9249bad86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-685f-773a-b571-19d9249bad86",
        "storage_key": "property/6767906449167487/019e1849-685f-773a-b571-19d9249bad86.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.auroragov.org/things_to_do/parks__open_space___trails/aurora_sports_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=9912678290251124215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aurora-sports-park",
      "poi_latitude": "39.7333059",
      "poi_longitude": "-104.7593058",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 303-739-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b6-74f5-8944-44da96564973",
        "storage_key": "property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmcvpqtFjbIcR9w0lp2LokIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aa5ad587-578d-4c6f-90e6-8ae543b73fd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Four Mile Historic Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "715 S Forest St, Denver, CO 80246, USA",
      "poi_short_description": "Museum & park set on 12 acres includes an 1800s log cabin, barn with farm animals & guided tours.",
      "poi_long_description": "People say this park offers fun light shows and displays, especially during holiday events. They highlight the creative and beautiful light art, and the open walking space suitable for families and dates. They also like the intimate atmosphere and the historical information provided throughout the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7160-759e-a24b-900d30dcca5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7160-759e-a24b-900d30dcca5c",
        "storage_key": "property/6767906449167487/019e1849-7160-759e-a24b-900d30dcca5c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://fourmilepark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5122670447582721355&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-mile-historic-park",
      "poi_latitude": "39.7035422",
      "poi_longitude": "-104.9292325",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 720-865-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b6-74f5-8944-44da96564973",
        "storage_key": "property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMQiGfNJ9bIcRSzWPiaFhF0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c46de5a-0800-4108-9311-06901464d85e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "City Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3181 E 23rd Ave, Denver, CO 80205, USA",
      "poi_short_description": "Urban golf course with views across the cityscape & a restaurant terrace popular for Sunday lunches.",
      "poi_long_description": "People say this golf course has a challenging and fun redesigned course with beautiful views of downtown Denver and the mountains, and a nice driving range. They also highlight the excellent food and service at the clubhouse.\n\nSome reviews mention the greens can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6b74-76bc-b0b6-bcc1db99b8bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6b74-76bc-b0b6-bcc1db99b8bb",
        "storage_key": "property/6767906449167487/019e1849-6b74-76bc-b0b6-bcc1db99b8bb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.cityofdenvergolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13731292430056108739&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-park-golf-course",
      "poi_latitude": "39.7523883",
      "poi_longitude": "-104.9488316",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 720-865-3410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82e8-7270-9387-b50e0fc4be22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82e8-7270-9387-b50e0fc4be22",
        "storage_key": "property/6767906449167487/019e1849-82e8-7270-9387-b50e0fc4be22.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJgd5vA1B5bIcRwzKBsLZZj74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_d15e8952-c9fb-4585-9a62-cdc28101576c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Wildlife Drive at the Rocky Mountain Arsenal",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Potomac Street, Denver, CO 80239, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this wildlife refuge offers a scenic drive with opportunities to see bison, deer, and prairie dogs. They highlight the peaceful and therapeutic vibe, and the breathtaking views of the Rocky Mountains. They also like that it's free and conveniently located near the airport.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6fc9-73d7-a3a2-a95fcf9c1524.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6fc9-73d7-a3a2-a95fcf9c1524",
        "storage_key": "property/6767906449167487/019e1849-6fc9-73d7-a3a2-a95fcf9c1524.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fws.gov/refuge/Rocky_Mountain_Arsenal/visit/visitor_activities.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16500591805158004940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wildlife-drive-at-the-rocky-mountain-arsenal",
      "poi_latitude": "39.819491",
      "poi_longitude": "-104.8277372",
      "poi_miles_from_property": "11.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 303-289-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b6-74f5-8944-44da96564973",
        "storage_key": "property/6767906449167487/019e1849-82b6-74f5-8944-44da96564973.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6hcf0llbIcRzBgqqtLg_eQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_967684a4-44c9-4b14-9e70-e91b8d97d66d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Central Park",
      "poi_type": "Transportation & Transit",
      "poi_address": "8200 Smith Rd, Denver, CO 80207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6c2b-7000-b2f3-18a3090f8b45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6c2b-7000-b2f3-18a3090f8b45",
        "storage_key": "property/6767906449167487/019e1849-6c2b-7000-b2f3-18a3090f8b45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5449205304609039896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "central-park",
      "poi_latitude": "39.7705735",
      "poi_longitude": "-104.8917631",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-856e-75b7-b382-a587504f7470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-856e-75b7-b382-a587504f7470",
        "storage_key": "property/6767906449167487/019e1849-856e-75b7-b382-a587504f7470.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJBWQ6_p97bIcRGGZleVp3n0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_dd74f350-e10c-4bc1-90f8-465dc7f8b486",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "61st & Pena Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Denver, CO 80249, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7018-7168-bca7-fa3cd4a2b94e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7018-7168-bca7-fa3cd4a2b94e",
        "storage_key": "property/6767906449167487/019e1849-7018-7168-bca7-fa3cd4a2b94e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1690982542578165105&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "61st--pena-station",
      "poi_latitude": "39.8070165",
      "poi_longitude": "-104.7839388",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-856e-75b7-b382-a587504f7470.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-856e-75b7-b382-a587504f7470",
        "storage_key": "property/6767906449167487/019e1849-856e-75b7-b382-a587504f7470.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXq1HLNlbIcRcSXCy6mTdxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_8e70b645-44db-4d36-9401-4bb2cb302edd",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Florida Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-6d62-722a-bc65-1d14f5172ae4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-6d62-722a-bc65-1d14f5172ae4",
        "storage_key": "property/6767906449167487/019e1849-6d62-722a-bc65-1d14f5172ae4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10350713926922194592&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "florida-station",
      "poi_latitude": "39.6900936",
      "poi_longitude": "-104.8285012",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8VGZXbtibIcRoM7i4XkfpY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_9d1b29a9-0ca2-4127-8634-6f7a5e403124",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Fitzsimons Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-74e2-7292-ba07-f4eed0a50e25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-74e2-7292-ba07-f4eed0a50e25",
        "storage_key": "property/6767906449167487/019e1849-74e2-7292-ba07-f4eed0a50e25.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10342629173815300619&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fitzsimons-station",
      "poi_latitude": "39.7550027",
      "poi_longitude": "-104.8405409",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBfs-iVZjbIcRC1LanG9miI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_ad8406f8-d8d9-4fbb-b36f-740d0aa70c88",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "13th Ave Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-74bb-7128-8133-77ea0f3cae02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-74bb-7128-8133-77ea0f3cae02",
        "storage_key": "property/6767906449167487/019e1849-74bb-7128-8133-77ea0f3cae02.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11693487283026727761&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "13th-ave-station",
      "poi_latitude": "39.7349666",
      "poi_longitude": "-104.8236429",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4YcdT5jbIcRURNbqrqcR6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_56e82dd0-72b9-4af5-a6ac-181754437733",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "UCHealth Leprino Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12401 E 17th Ave, Aurora, CO 80045, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7792-748b-b441-50df02ee7172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7792-748b-b441-50df02ee7172",
        "storage_key": "property/6767906449167487/019e1849-7792-748b-b441-50df02ee7172.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-leprino-building/",
      "poi_directions_map_url": "https://maps.google.com/?cid=229662277627742138&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uchealth-leprino-building",
      "poi_latitude": "39.7440071",
      "poi_longitude": "-104.8427734",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 720-848-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB_wH-UxjbIcRugdP7J_sLwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_047825ef-f59b-49a7-8f7b-6cce0ee67fd0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Stafford Logistics Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "20500 E Colfax Ave, Aurora, CO 80018, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-779c-708a-ad40-64fb7f84d982.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-779c-708a-ad40-64fb7f84d982",
        "storage_key": "property/6767906449167487/019e1849-779c-708a-ad40-64fb7f84d982.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.staffordlogisticscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16053385422270128797&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stafford-logistics-center",
      "poi_latitude": "39.7379565",
      "poi_longitude": "-104.7482493",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS-SlS7dhbIcRnWLYsPwUyd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a2dbe979-b47d-42dc-aae1-ba5051666126",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Roper Apparel Warehouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16456 E Airport Cir Suite 200, Aurora, CO 80011, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7847-772c-b9b5-22184d1ee93a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7847-772c-b9b5-22184d1ee93a",
        "storage_key": "property/6767906449167487/019e1849-7847-772c-b9b5-22184d1ee93a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.roperwarehousesale.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10719240554872693813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roper-apparel-warehouse",
      "poi_latitude": "39.7592398",
      "poi_longitude": "-104.7947591",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06CmTIFjbIcRNeQl331kwpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9cb3d56a-b0c5-46f3-a2aa-ba529b567af2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Panasonic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6144 N Panasonic Way #100, Denver, CO 80249, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7abd-707d-8694-87b4733113fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7abd-707d-8694-87b4733113fd",
        "storage_key": "property/6767906449167487/019e1849-7abd-707d-8694-87b4733113fd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://business.panasonic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9200166806014395169&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "panasonic",
      "poi_latitude": "39.80934",
      "poi_longitude": "-104.7809495",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSY6b7VlbIcRIQPUKveOrX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5079f8a1-a39b-4bc8-a998-fad6ec641b1d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "InnovAge Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8950 E Lowry Blvd, Denver, CO 80230, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-7cd0-7008-818e-cd4b1fb3b33a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1849-7cd0-7008-818e-cd4b1fb3b33a",
        "storage_key": "property/6767906449167487/019e1849-7cd0-7008-818e-cd4b1fb3b33a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.innovage.com/locations/co-headquarters",
      "poi_directions_map_url": "https://maps.google.com/?cid=17484333812638488800&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "innovage-headquarters",
      "poi_latitude": "39.723944",
      "poi_longitude": "-104.8828886",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 303-835-4685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9VV8Q_B8bIcR4BirdPfUpPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4c6dcdb5-e5fb-4310-b452-15c7b3899538",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "509 Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "10180 E Colfax Ave unit 117, Aurora, CO 80010, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this Haitian restaurant's authentic and flavorful dishes, including tender fried goat, seasoned tilapia, and creamy mac and cheese. They also highlight the generous portions and reasonable prices, offering great value. Guests mention the warm, welcoming atmosphere and the kind, attentive staff who provide excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184d-0b8f-72f1-9c62-ea69318cb287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e184d-0b8f-72f1-9c62-ea69318cb287",
        "storage_key": "property/6767906449167487/019e184d-0b8f-72f1-9c62-ea69318cb287.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.instagram.com/509_cuisine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2057495924341183313&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "509-cuisine",
      "poi_latitude": "39.739778",
      "poi_longitude": "-104.869816",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-850-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX8zlFwB9bIcRUZMrYaSxjRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_71125515-4849-4142-bdae-e7401e132356",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "El Cazuelazo Colombiano",
      "poi_type": "Restaurants",
      "poi_address": "10109 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e551-76ee-8afd-331a4e8a03ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e551-76ee-8afd-331a4e8a03ba",
        "storage_key": "property/6767906449167487/019e4acc-e551-76ee-8afd-331a4e8a03ba.webp",
        "width": 1272,
        "height": 1280
      },
      "poi_business_url": "http://elcazuelazocolombiano.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8766599578093403543&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-cazuelazo-colombiano",
      "poi_latitude": "39.74039399999999",
      "poi_longitude": "-104.8702265",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-705-0649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuw4lVwB9bIcRl71YbN43qXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "colombian_restaurant"
    },
    {
      "id": "custom_aa1d19f4-1da1-4c6c-ac17-c7076a645061",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Urban Burma",
      "poi_type": "Restaurants",
      "poi_address": "10180 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Shan noodles, beef curry & other Burmese dishes served in an unassuming stall within a food hall.",
      "poi_long_description": "Diners say this Burmese restaurant serves up delicious tea leaf salad, samosas, and chicken curry. They also highlight the friendly and helpful staff, and the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e59f-73d9-a0c5-a7845c30cdaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e59f-73d9-a0c5-a7845c30cdaa",
        "storage_key": "property/6767906449167487/019e4acc-e59f-73d9-a0c5-a7845c30cdaa.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://www.urbanburma.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12110996033631108531&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-burma",
      "poi_latitude": "39.7398814",
      "poi_longitude": "-104.8697997",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 626-628-5430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiY5Uynx9bIcRsz2_zLnmEqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "burmese_restaurant"
    },
    {
      "id": "custom_6a5e74a3-aefc-46da-bcd7-b06bf7eef5b1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Tata & Nono Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10180 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Family-friendly restaurant serving fresh and flavorful Sudanese dishes and coffee.",
      "poi_long_description": "Diners say this North African restaurant serves up delicious fish, lamb and beef kabobs, and tilapia with rice. They also highlight the friendly and gracious staff, and the authentic Sudanese coffee and spicy peanut sauce.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-ea3a-7169-b421-bcbb7a761c88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-ea3a-7169-b421-bcbb7a761c88",
        "storage_key": "property/6767906449167487/019e4acc-ea3a-7169-b421-bcbb7a761c88.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tatanonokitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1244338875300624705&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tata--nono-kitchen",
      "poi_latitude": "39.7398443",
      "poi_longitude": "-104.8697856",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-954-5353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRezEwB9bIcRQbmAQp3HRBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_80a3edb8-d945-4de1-a136-4fa4e2cb2cd3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Dan Da",
      "poi_type": "Restaurants",
      "poi_address": "9945 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Informal restaurant dishing up traditional Vietnamese fare, such as noodles, bowls and stir-fries.",
      "poi_long_description": "People say this Vietnamese restaurant offers a wide variety of dishes, including Bo Luc Lac beef, Bun Rieu soup, and a build-your-own spring roll tower, with generous portions and flavorful broths. They highlight the authentic and delicious food, and the reasonable prices. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e596-70c2-ac75-eac78b843f2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e596-70c2-ac75-eac78b843f2c",
        "storage_key": "property/6767906449167487/019e4acc-e596-70c2-ac75-eac78b843f2c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dandavn.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4525245607389449366&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dan-da",
      "poi_latitude": "39.7403183",
      "poi_longitude": "-104.8723906",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-476-7183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-G34G99bIcRlkzYdefmzD4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_4da4f112-7a35-4409-9a42-5b23ebbb27a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "JASMINE SYRIAN FOOD",
      "poi_type": "Restaurants",
      "poi_address": "10180 E Colfax Ave STE 118, Aurora, CO 80010, USA",
      "poi_short_description": "Standard food court outlet specializing in homestyle Middle Eastern dishes & desserts.",
      "poi_long_description": "People say this restaurant serves delicious chicken shawarma, falafel, kebab, and hummus. They highlight the fresh and flavorful food, and the generous portion sizes. They also like the friendly staff and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f66d-720b-9f80-66c7196911d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f66d-720b-9f80-66c7196911d6",
        "storage_key": "property/6767906449167487/019e4acc-f66d-720b-9f80-66c7196911d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jasminesyrian.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7998719048240813228&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jasmine-syrian-food",
      "poi_latitude": "39.7398822",
      "poi_longitude": "-104.869796",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-418-1776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ63GZQNV9bIcRrFSLaJgoAW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6bd99ef4-767f-4745-8d6d-ade14adc3a5e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Phở Peoria",
      "poi_type": "Restaurants",
      "poi_address": "1695 Peoria St, Aurora, CO 80010, USA",
      "poi_short_description": "Laid-back venue for classic Vietnamese eats like pho noodle soup, rice plates & stir fries.",
      "poi_long_description": "People say this Vietnamese restaurant serves delicious pho, crab cheese wontons, and spring rolls. They highlight the generous portions, reasonable prices, and clean atmosphere. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184c-f807-77a1-97a8-3cdbf849efe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e184c-f807-77a1-97a8-3cdbf849efe7",
        "storage_key": "property/6767906449167487/019e184c-f807-77a1-97a8-3cdbf849efe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.phopeoria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15741385392423568374&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ph-peoria",
      "poi_latitude": "39.7435851",
      "poi_longitude": "-104.8475087",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-360-6688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFSKFHLN8bIcR9gPu65yidNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_50fee5b3-3ac6-46a3-a443-1dc2681ffdc9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Nepali Spice",
      "poi_type": "Restaurants",
      "poi_address": "10180 E Colfax Ave Ste 115, Aurora, CO 80010, USA",
      "poi_short_description": "Casual, family-owned spot offering an expansive menu of Nepalese and Indian comfort food, including chicken tikka masala, as well as momo dumplings, samosas and noodle dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e897-7347-808e-b3c464027836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e897-7347-808e-b3c464027836",
        "storage_key": "property/6767906449167487/019e4acc-e897-7347-808e-b3c464027836.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1722189682533172219&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nepali-spice",
      "poi_latitude": "39.739778",
      "poi_longitude": "-104.869816",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-507-6647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZNBJvl9bIcR-4M7R2Ry5hc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_03711dca-42a1-4021-894c-a7ea99ac7b4b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Big belly brothers bbq",
      "poi_type": "Restaurants",
      "poi_address": "11601 E Montview Blvd, Aurora, CO 80010, USA",
      "poi_short_description": "Mobile, quick-service caterer known for BBQ eats such as brisket.",
      "poi_long_description": "People say this food truck serves delicious brisket, burnt ends, and mac and cheese. They highlight the generous portions, flavorful sauces, and fast service. They also like the friendly staff and great energy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-ea34-70d1-aa80-89ffab6565e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-ea34-70d1-aa80-89ffab6565e6",
        "storage_key": "property/6767906449167487/019e4acc-ea34-70d1-aa80-89ffab6565e6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.bigbellybrothersbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1689895419938614041&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "big-belly-brothers-bbq",
      "poi_latitude": "39.7476253",
      "poi_longitude": "-104.8526902",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 983-214-9478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ75Uwdt9bIcRGSsAVe62cxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_76b22622-ace9-4467-b2a9-ff9ad7cd5069",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Dragon Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "9598 E Montview Blvd, Aurora, CO 80010, USA",
      "poi_short_description": "Authentic Chinese fare (including General Tso’s) in a casual space featuring lunch and dinner options, plus takeout.",
      "poi_long_description": "Diners say this Chinese restaurant serves up delicious hot and sour soup, fried rice, and General Tso's chicken. They also highlight the friendly staff and reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e546-775e-a3d3-c1aa599ba5a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e546-775e-a3d3-c1aa599ba5a6",
        "storage_key": "property/6767906449167487/019e4acc-e546-775e-a3d3-c1aa599ba5a6.webp",
        "width": 1242,
        "height": 1108
      },
      "poi_business_url": "https://www.dragonkitchengo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8148318227016068314&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dragon-kitchen",
      "poi_latitude": "39.74721479999999",
      "poi_longitude": "-104.8766503",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-301-7399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgSprfQt9bIcR2iwifkGkFHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_58d7b2df-10ed-41c1-a49a-9b27673b8681",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "La Cueva Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9742 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Spicy green chili, a laid-back atmosphere & tons of tequila star at this family-owned Mexican spot.",
      "poi_long_description": "People say this Mexican restaurant serves delicious food, including tacos, tamales, and enchiladas. They also highlight the friendly service and the authentic, family-owned atmosphere.\n\nOther reviews mention the food can be watery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-e9dd-702d-bb1b-987bb53611b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-e9dd-702d-bb1b-987bb53611b8",
        "storage_key": "property/6767906449167487/019e4acc-e9dd-702d-bb1b-987bb53611b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lacuevacolfax.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6665125586546050663&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-cueva-restaurant",
      "poi_latitude": "39.7400035",
      "poi_longitude": "-104.8744252",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-367-4071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNakS1JZ8bIcRZ8ZxWWhIf1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_bfe20670-d762-4378-9974-418a26c8ffa3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Real De Minas Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "11101 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Cheerful eatery with an extensive menu of classic fare, plus a mariachi band on the weekend.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos al pastor, shrimp a la diabla, and margaritas. They also highlight the lively atmosphere with live Mariachi bands and the attentive service from the staff.\n\nOther reviews mention the drinks can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-ee99-753c-896e-13e9972035b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-ee99-753c-896e-13e9972035b0",
        "storage_key": "property/6767906449167487/019e4acc-ee99-753c-896e-13e9972035b0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://realdeminasrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10817438262593459577&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "real-de-minas-mexican-grill",
      "poi_latitude": "39.7403644",
      "poi_longitude": "-104.8585278",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-367-1504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtYS3Gbp8bIcReRWaXclCH5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_eb0cf8df-d7e1-40b1-b731-efe2d36667ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Mason's Dumpling Shop - Aurora",
      "poi_type": "Restaurants",
      "poi_address": "9655 E Montview Blvd, Aurora, CO 80010, USA",
      "poi_short_description": "Informal Chinese restaurant turning out handcrafted dumplings made from locally sourced ingredients.",
      "poi_long_description": "People say this dumpling restaurant serves delicious dumplings, bao buns, and vegetarian beef bowls. They also highlight the reasonable prices, friendly staff, and quick service.\n\nSome reviews mention the ordering system can be impersonal.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-ee95-712d-9ee2-f58808fbf8b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-ee95-712d-9ee2-f58808fbf8b3",
        "storage_key": "property/6767906449167487/019e4acc-ee95-712d-9ee2-f58808fbf8b3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://order.online/business/-233302",
      "poi_directions_map_url": "https://maps.google.com/?cid=7983747305907221970&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "masons-dumpling-shop---aurora",
      "poi_latitude": "39.7476362",
      "poi_longitude": "-104.8756999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-600-8998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgT-hM5d9bIcR0vUUAeD3y24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dumpling_restaurant"
    },
    {
      "id": "custom_856d1384-01a1-4c8d-b399-2e6e73e76af0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Los Toritos Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9405 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "No-frills Mexican bar & eatery featuring grilled meats & seafood plus karaoke on weekends.",
      "poi_long_description": "Guests consistently praise this restaurant for its friendly and accommodating staff, alongside a fun and energetic atmosphere. The delicious seafood fajitas and ceviche are frequently highlighted as standout menu items.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f080-76c8-9290-1658cb13e22f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f080-76c8-9290-1658cb13e22f",
        "storage_key": "property/6767906449167487/019e4acc-f080-76c8-9290-1658cb13e22f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2960690309316070083&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "los-toritos-mexican-restaurant",
      "poi_latitude": "39.740322",
      "poi_longitude": "-104.8785577",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-366-6381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsdQkT5B8bIcRw8q5YCZ8Fik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ae0532ac-59f3-4343-81db-3b9ccec2ac81",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "La Guatemalteca",
      "poi_type": "Restaurants",
      "poi_address": "10329 E Colfax Ave, Aurora, CO 80010, USA",
      "poi_short_description": "Casual restaurant for authentic Guatemalan comfort food, from tamales to caldo de gallina.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f3a2-730c-bc46-067c2359e2b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f3a2-730c-bc46-067c2359e2b5",
        "storage_key": "property/6767906449167487/019e4acc-f3a2-730c-bc46-067c2359e2b5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.laguatemaltecarestaurante.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11626007479371987752&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-guatemalteca",
      "poi_latitude": "39.7405442",
      "poi_longitude": "-104.8674068",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-343-2838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbMjvr18bIcRKHsAjDTgV6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "latin_american_restaurant"
    },
    {
      "id": "custom_ebac6c36-b310-4b13-af58-9288ce9b1b1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Tocoa in the House",
      "poi_type": "Restaurants",
      "poi_address": "1981 Clinton St, Aurora, CO 80010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f12d-726d-b467-6e73b6eb3cb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f12d-726d-b467-6e73b6eb3cb0",
        "storage_key": "property/6767906449167487/019e4acc-f12d-726d-b467-6e73b6eb3cb0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10297731757220155175&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tocoa-in-the-house",
      "poi_latitude": "39.7469997",
      "poi_longitude": "-104.8779839",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-856-3413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHW1cG_R9bIcRJ89dNXnk6I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d3b1cc17-63b0-4eb2-ba7a-3379ca64eb49",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Taco River",
      "poi_type": "Restaurants",
      "poi_address": "1685 Peoria St, Aurora, CO 80010, USA",
      "poi_short_description": "Casual eatery cooking up a menu of Mexican standards like gorditas, burritos, tacos and chili cheese fries, with counter-service.",
      "poi_long_description": "People say this Mexican restaurant offers great street tacos and salsas. They also highlight the reasonable prices and friendly service.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f218-741a-b1d6-ebf06dd937a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f218-741a-b1d6-ebf06dd937a8",
        "storage_key": "property/6767906449167487/019e4acc-f218-741a-b1d6-ebf06dd937a8.webp",
        "width": 1024,
        "height": 768
      },
      "poi_business_url": "https://taco-river.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13004892606557710414&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "taco-river",
      "poi_latitude": "39.7433977",
      "poi_longitude": "-104.8473868",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-364-9275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSDkMLZ9bIcRTuj5O-yoerQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_e43122a4-6c92-47e7-ba60-95bf02a1b7f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Tacos Del Valle Inc",
      "poi_type": "Restaurants",
      "poi_address": "10100 E Montview Blvd, Aurora, CO 80010, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f429-777c-958f-f38541eafd8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f429-777c-958f-f38541eafd8c",
        "storage_key": "property/6767906449167487/019e4acc-f429-777c-958f-f38541eafd8c.webp",
        "width": 592,
        "height": 1280
      },
      "poi_business_url": "http://ordertacosdelvalleinc.mobile-webview6.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18254542377424783194&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tacos-del-valle-inc",
      "poi_latitude": "39.7471131",
      "poi_longitude": "-104.8702037",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 303-356-7167",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b8-7149-bb5a-c78403bbaf53",
        "storage_key": "property/6767906449167487/019e1849-82b8-7149-bb5a-c78403bbaf53.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdRjMntjbIcRWge4V5MpVf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cfdc4676-a650-4693-a902-6d1bbe71c62b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Miss Millie’s Kitchen Catering LLC",
      "poi_type": "Restaurants",
      "poi_address": "9905 E Colfax Ave Unit B, Aurora, CO 80010, USA",
      "poi_short_description": "Caterer providing soul food dishes like catfish and red beans and rice, plus cakes and cupcakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4acc-f46f-71dd-9e5b-4f2cf36047dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4acc-f46f-71dd-9e5b-4f2cf36047dd",
        "storage_key": "property/6767906449167487/019e4acc-f46f-71dd-9e5b-4f2cf36047dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.missmillieskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6218269783722558335&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "miss-millies-kitchen-catering-llc",
      "poi_latitude": "39.740365",
      "poi_longitude": "-104.8727123",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 720-758-0550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwMgztl9bIcRfwNUKGy7S1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "catering_service"
    },
    {
      "id": "custom_551f3db2-dd3c-40f4-abaf-218fd3f0ff55",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Crawford Elementary School",
      "poi_type": "Education",
      "poi_address": "1600 Florence St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://crawford.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7517565708741060085&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "crawford-elementary-school",
      "poi_latitude": "39.7429407",
      "poi_longitude": "-104.8711065",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-340-3290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7TKEhZd8bIcR9SUrrS7CU2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d488440f-54e7-4ac2-ba19-3fc16e28e4db",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "New America School",
      "poi_type": "Education",
      "poi_address": "1564 Elmira St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-674f-7712-887c-b71c7c6fb190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-674f-7712-887c-b71c7c6fb190",
        "storage_key": "property/6767906449167487/019e4ad2-674f-7712-887c-b71c7c6fb190.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://newamericaschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11925923523658772054&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-america-school",
      "poi_latitude": "39.7414301",
      "poi_longitude": "-104.8726179",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-320-9854",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP9bX1MuGa4cRVu4nLkJkgaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b0cc36b4-fd09-44d7-bc10-9d800268aee4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "North Middle School",
      "poi_type": "Education",
      "poi_address": "12095 E Montview Blvd, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184d-0862-708b-b0ea-2c7476ef1dd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e184d-0862-708b-b0ea-2c7476ef1dd3",
        "storage_key": "property/6767906449167487/019e184d-0862-708b-b0ea-2c7476ef1dd3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://north.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18219894738334897140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "north-middle-school",
      "poi_latitude": "39.74830619999999",
      "poi_longitude": "-104.8479233",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-364-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEcGAdK18bIcR9NN1O7sR2vw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6aca92f5-e919-4c62-a8e0-f9ad1c1f65f2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "The Denver Street School - East Campus",
      "poi_type": "Education",
      "poi_address": "1585 Kingston St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://denverstreetschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2191850185791253358&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-denver-street-school---east-campus",
      "poi_latitude": "39.74153099999999",
      "poi_longitude": "-104.8590979",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-935-2154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqezsRrp8bIcRbiv2jCEEax4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_2fe520e1-117c-480c-a73e-a9150971f0d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Montview Elementary School",
      "poi_type": "Education",
      "poi_address": "2055 N Moline St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-6423-734a-ba43-d083ef4b72e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-6423-734a-ba43-d083ef4b72e9",
        "storage_key": "property/6767906449167487/019e4ad2-6423-734a-ba43-d083ef4b72e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://montview.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7926523163800366516&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "montview-elementary-school",
      "poi_latitude": "39.7483042",
      "poi_longitude": "-104.8545829",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-364-8549",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDchYEq98bIcRtO05KtKqAG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_1f428cb8-b3b5-4b85-b87e-e1d6d18eb5be",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "William Roberts Elementary",
      "poi_type": "Education",
      "poi_address": "2100 N Akron Way, Denver, CO 80238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://billroberts.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6018674182103576858&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "william-roberts-elementary",
      "poi_latitude": "39.7480145",
      "poi_longitude": "-104.8835432",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-424-2640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCzIxDoN8bIcRGjEZw0eghlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_fa658ff9-c0af-4f88-b553-a66a805a106b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "New Legacy Charter School",
      "poi_type": "Education",
      "poi_address": "2091 Dayton St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.newlegacycharter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=948297154189320277&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "new-legacy-charter-school",
      "poi_latitude": "39.7487939",
      "poi_longitude": "-104.875738",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-340-7880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDcoXFpx8bIcRVeD3yDwHKQ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c0c12f28-7dcb-45d1-b74c-b97564d39d7f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Vega Collegiate Academy",
      "poi_type": "Education",
      "poi_address": "1400 Yosemite St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-67aa-712a-b4f4-bcfe13ce236b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-67aa-712a-b4f4-bcfe13ce236b",
        "storage_key": "property/6767906449167487/019e4ad2-67aa-712a-b4f4-bcfe13ce236b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.vegacollegiateacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9502528611478754223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vega-collegiate-academy",
      "poi_latitude": "39.7391327",
      "poi_longitude": "-104.8844152",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-390-6975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvbXV9J99bIcRr1Mt82zD34M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_34c28e15-93d0-4f99-bba8-d2407eced395",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Boston K-8 School",
      "poi_type": "Education",
      "poi_address": "1365 Boston St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-6361-760e-b26f-c63eae96b9da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-6361-760e-b26f-c63eae96b9da",
        "storage_key": "property/6767906449167487/019e4ad2-6361-760e-b26f-c63eae96b9da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://boston.aurorak12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4208487832336902905&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "boston-k-8-school",
      "poi_latitude": "39.7379618",
      "poi_longitude": "-104.8805386",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-364-6878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxaPIHo58bIcR-ar-z2KNZzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_28a5a41d-ae1e-4e05-b211-ea745f1c63da",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Isabella Bird Community School",
      "poi_type": "Education",
      "poi_address": "2701 N Lima St, Denver, CO 80238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-6c10-7463-acab-e5e02ee49c4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-6c10-7463-acab-e5e02ee49c4d",
        "storage_key": "property/6767906449167487/019e4ad2-6c10-7463-acab-e5e02ee49c4d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://isabellabird.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3709542757479648518&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "isabella-bird-community-school",
      "poi_latitude": "39.7554189",
      "poi_longitude": "-104.8574105",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-423-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHZUSwdQQcEARBo2y4nvxejM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_7e680c66-6fac-4f46-816f-23bc01864422",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Colorado Community College System",
      "poi_type": "Education",
      "poi_address": "9101 E Lowry Blvd, Denver, CO 80230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-682c-769e-ba8e-6377ec22447e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-682c-769e-ba8e-6377ec22447e",
        "storage_key": "property/6767906449167487/019e4ad2-682c-769e-ba8e-6377ec22447e.webp",
        "width": 1280,
        "height": 627
      },
      "poi_business_url": "https://www.cccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6448780711794670287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "colorado-community-college-system",
      "poi_latitude": "39.7263009",
      "poi_longitude": "-104.8798614",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-620-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ81LCbfJ8bIcRz3rp6OOrflk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_77db6c29-5ab9-4523-bf04-ee9b08f205c4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Community College of Aurora​ - CentreTech Campus",
      "poi_type": "Education",
      "poi_address": "16000 E Centretech Pkwy, Aurora, CO 80011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184d-20a2-75ea-9fff-9e53a3d887a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e184d-20a2-75ea-9fff-9e53a3d887a9",
        "storage_key": "property/6767906449167487/019e184d-20a2-75ea-9fff-9e53a3d887a9.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ccaurora.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10228440369385316687&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "community-college-of-aurora---centretech-campus",
      "poi_latitude": "39.7178373",
      "poi_longitude": "-104.8027665",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-360-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJgTT1RNljbIcRTyF6x1K48o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ece1c9d0-cce3-40a1-b9a1-5d0593b924a6",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Northeast Early College",
      "poi_type": "Education",
      "poi_address": "11200 E 45th Ave, Denver, CO 80239, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://nec.dpsk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7145273019136102603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northeast-early-college",
      "poi_latitude": "39.7760487",
      "poi_longitude": "-104.8533121",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-424-2450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbyHVJzZ7bIcRy1DKIPQbKWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5e5accb7-956d-45f9-ad46-707fb381e03f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Concorde Career College - Aurora",
      "poi_type": "Education",
      "poi_address": "111 Havana St, Aurora, CO 80010, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e184d-10bd-7679-859e-9617a3e575ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e184d-10bd-7679-859e-9617a3e575ef",
        "storage_key": "property/6767906449167487/019e184d-10bd-7679-859e-9617a3e575ef.webp",
        "width": 785,
        "height": 785
      },
      "poi_business_url": "https://www.concorde.edu/campus/aurora-colorado?utm_source=google&utm_medium=organic&utm_campaign=knowledge&utm_term=aurora&SourceID=GO1106&school_ad_platform=organic&school_source=gmb&school_campus=CODEN&school_program=GENERAL",
      "poi_directions_map_url": "https://maps.google.com/?cid=146766732242413866&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "concorde-career-college---aurora",
      "poi_latitude": "39.71896780000001",
      "poi_longitude": "-104.8661928",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 720-808-0455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfw0K3N18bIcRKmknvJBrCQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a231b3d5-ff7e-4022-ad9d-3edd1c9f286a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Columbia College-Denver",
      "poi_type": "Education",
      "poi_address": "15500 E Centretech Pkwy, Aurora, CO 80011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-63ce-7463-aff9-849fa0050809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-63ce-7463-aff9-849fa0050809",
        "storage_key": "property/6767906449167487/019e4ad2-63ce-7463-aff9-849fa0050809.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.ccis.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10110519224681445344&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "columbia-college-denver",
      "poi_latitude": "39.7249948",
      "poi_longitude": "-104.8088032",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-771-0176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2XmHtCFjbIcR4DflwarHT4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ea9360de-fc39-4e6c-85a5-8122cf8e6fdf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Amazon - DEN8 E AURORA CO",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Stafford Logistics Center Building 5, 21000 E 13th Ave, Aurora, CO 80018, USA",
      "poi_short_description": "false",
      "poi_long_description": "Reviewers consistently praise this warehouse for its clean environment.\n\nOther reviews mention wait times can be excessively long and staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-630f-7182-9139-4b7cbff39a94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-630f-7182-9139-4b7cbff39a94",
        "storage_key": "property/6767906449167487/019e4ad2-630f-7182-9139-4b7cbff39a94.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15121749127363132559&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amazon---den8-e-aurora-co",
      "poi_latitude": "39.73577",
      "poi_longitude": "-104.7435032",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtayIuY9hbIcRj3wNf7Y-29E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_caa50e98-7826-4c1f-9aaf-ac6ef30f8fce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "Raytheon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "16510 Hughes Dr S75, Aurora, CO 80011, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4107115575897463936&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raytheon",
      "poi_latitude": "39.7141121",
      "poi_longitude": "-104.795936",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82b9-7740-8ca9-46a72ddba7f2",
        "storage_key": "property/6767906449167487/019e1849-82b9-7740-8ca9-46a72ddba7f2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuZvnAxxjbIcRgJzXGNtn_zg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e54277e7-4c7d-49b9-a1db-221e5cb45576",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "custom",
      "poi_name": "University of Northern Colorado Denver Center at Lowry",
      "poi_type": "Education",
      "poi_address": "1059 Alton Way, Denver, CO 80230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e4ad2-661f-756c-bf62-6ab63d37ba29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e4ad2-661f-756c-bf62-6ab63d37ba29",
        "storage_key": "property/6767906449167487/019e4ad2-661f-756c-bf62-6ab63d37ba29.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://extended.unco.edu/about/centers/denver-lowry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14310324091096835485&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-northern-colorado-denver-center-at-lowry",
      "poi_latitude": "39.72984",
      "poi_longitude": "-104.8835066",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 303-637-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1849-82ed-744d-ab12-27da15ae9ef1",
        "storage_key": "property/6767906449167487/019e1849-82ed-744d-ab12-27da15ae9ef1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0fKEAvN8bIcRnaWKBvF7mMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_78e64180e3726a5718926975",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_1b203f652f604b17b90454ae",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_543aafcdfc66cdb75c2d9e06",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_76ea9799e895defd8b39d511",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_cfc333d08bedc8b432579f21",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_9e4adbdc-38ca-4676-9a60-a6d5a334c4d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "rating": "5.0",
      "name": "Chris Lav",
      "text": "My wife and I have lived here for five years, and it’s been an amazing experience. The staff is incredibly friendly, professional, and always willing to help. They’re constantly making improvements to keep the property looking great and the community feeling welcoming.\n\nMaintenance is outstanding  anytime we’ve had an issue It was fixed quickly and efficiently\n\nOnly major down side is that utilities are expensive and never consistent month-to-month but not sure if that's every apartment complex or just here\nI would recommend this place to a friend",
      "date": "2026-02-26",
      "title": ""
    },
    {
      "id": "custom_07584116-ed9a-4164-9563-0928ae540c3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "rating": "5.0",
      "name": "Marcos E",
      "text": "I've had a great experience at Ascent at Fitzsimons Apartments.The community feels very safe, and the apartments are clean, modern, and well-maintained. The maintenance team is responsive and professional, and the staff is always friendly and helpful. I’d definitely recommend Ascent at Fitzsimons to anyone looking for a quality apartment in the area!",
      "date": "2025-08-13",
      "title": ""
    },
    {
      "id": "custom_bc7438fb-4833-4e44-81f3-14faccafb695",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "rating": "5.0",
      "name": "Harouna Sow",
      "text": "Maintenance guy carlos and the supervisor cesar did a good job at my apartment 85-202",
      "date": "2026-01-27",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1cca-89e5-712a-b6a4-aae92cc5bcf3",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-ascent-at-fitzsimmons",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-with-bbq-picnic-area-aurora-co",
      "search_query": "apartments with BBQ picnic area Aurora CO",
      "category": "Amenity",
      "h1_title": "Apartments with BBQ Picnic Area in Aurora, CO",
      "h2_subtitle": "Discover the perfect apartment with a BBQ picnic area in Aurora, CO. Experience community living at Ascent at Fitzsimmons.",
      "page_copy": "Set in the vibrant heart of North Aurora Division, Ascent at Fitzsimmons offers more than a place to live. Our community is perfect for those seeking apartments with BBQ picnic area in Aurora, CO. Imagine enjoying sunny afternoons grilling and relaxing with friends and family in our thoughtfully designed outdoor spaces.\n\nOur community features such as a playground and a newly upgraded clubhouse add to the exceptional living experience. Select units come with luxurious granite countertops and sleek vinyl flooring, providing both comfort and style. Located conveniently near local amenities, Ascent at Fitzsimmons is the ideal place to call home in Adams County, CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with BBQ Picnic Area, Aurora CO",
      "seo_description": "Discover apartments with a BBQ picnic area at Ascent at Fitzsimmons in Aurora, CO. Perfect community living in the North Aurora Division.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "playground-apartments-adams-county",
      "search_query": "playground apartments in Adams County",
      "category": "Amenity",
      "h1_title": "Playground Apartments in Adams County",
      "h2_subtitle": "Explore inviting playground apartments in Adams County. Ideal family-friendly living at Ascent at Fitzsimmons.",
      "page_copy": "Welcome to Ascent at Fitzsimmons, nestled in the vibrant North Aurora Division of Adams County. Our community is perfect for families seeking playground apartments in Adams County. The on-site playground is perfect for children to play and families to connect, ensuring all ages enjoy the abundant amenities on offer.\n\nIn addition to the spacious playground, our community features modern accommodations including select units with granite countertops and durable vinyl flooring. Join a welcoming community that offers a range of facilities, including a renovated clubhouse and a BBQ picnic area, enhancing the quality of your lifestyle in Aurora, CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Apartments in Adams County",
      "seo_description": "Discover family-friendly playground apartments at Ascent at Fitzsimmons in Adams County. Enjoy great amenities and community living in Aurora, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "amazing-location-fitzsimmons-medical-campus-apartments",
      "search_query": "amazing location Fitzsimmons Medical Campus apartments",
      "category": "Amenity",
      "h1_title": "Amazing Location Near Fitzsimmons Medical Campus",
      "h2_subtitle": "Find apartments in an amazing location near Fitzsimmons Medical Campus. Enjoy easy access living at Ascent at Fitzsimmons.",
      "page_copy": "Experience unparalleled convenience at Ascent at Fitzsimmons, strategically situated near the Fitzsimmons Medical Campus. For those seeking an amazing location Fitzsimmons Medical Campus apartments, our community offers an ideal setting. Enjoy a seamless lifestyle with quick access to workplaces, educational institutions, and various everyday conveniences.\n\nWithin the welcoming confines of our community, you'll discover top-notch amenities including a playground, BBQ picnic area, and a recently upgraded clubhouse. The interior of select units boasts modern finishes with granite countertops and vinyl flooring, ensuring comfort and style. Make the smart choice by choosing Ascent at Fitzsimmons, where location meets luxury in Aurora, CO.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amazing Location Near Fitzsimmons Medical Campus",
      "seo_description": "Discover amazing location apartments near Fitzsimmons Medical Campus at Ascent at Fitzsimmons. Convenient living in Aurora, CO.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "new-appliances-apartments-north-aurora",
      "search_query": "new appliances apartments North Aurora",
      "category": "Amenity",
      "h1_title": "New Appliances in North Aurora Apartments",
      "h2_subtitle": "Experience modern living with new appliances in North Aurora. Find your home at Ascent at Fitzsimmons.",
      "page_copy": "Discover the ideal blend of style and convenience at Ascent at Fitzsimmons, located in the bustling North Aurora Division. If you're searching for new appliances apartments North Aurora, our community is perfect for you. Our renovated clubhouse and leasing office, combined with various upgraded units, make sure you feel right at home.\n\nResidents appreciate not just the modern comforts but also the range of communal amenities like a playground and BBQ picnic area. With these features, Ascent at Fitzsimmons provides an enhanced lifestyle, ensuring every moment spent in Aurora, CO, is both enjoyable and comfortable. Come home to a community where upgrades and modern living unite.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "New Appliances Apartments North Aurora",
      "seo_description": "Find new appliances apartments at Ascent at Fitzsimmons, offering modern living in North Aurora with great amenities. Welcome to your perfect home!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "granite-countertops-apartments-80010",
      "search_query": "granite countertops apartments 80010",
      "category": "Amenity",
      "h1_title": "Granite Countertops Apartments in 80010",
      "h2_subtitle": "Discover granite countertops apartments in 80010 at Ascent at Fitzsimmons. Enjoy luxurious living in North Aurora.",
      "page_copy": "Welcome to Ascent at Fitzsimmons, where elegance meets functionality in North Aurora. For those searching for granite countertops apartments in 80010, our community offers the perfect choice. Select units feature stunning granite countertops, adding a touch of luxury to your daily life.\n\nSet within a vibrant neighborhood, residents benefit from superb communal amenities like a playground and a BBQ picnic area. These enhancements, paired with a renovated clubhouse, provide a well-rounded living experience. Choose Ascent at Fitzsimmons for your home and enjoy upscale features that make life in Aurora, CO, truly exceptional.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apartments in 80010",
      "seo_description": "Find granite countertops apartments at Ascent at Fitzsimmons in 80010. Enjoy luxurious finishes and great amenities in North Aurora.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "studio-apartments-in-aurora-co",
      "search_query": "studio apartments in Aurora CO",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Aurora, CO",
      "h2_subtitle": "Explore stylish studio apartments in Aurora, CO at Ascent at Fitzsimmons. Enjoy the perfect balance of comfort and convenience.",
      "page_copy": "At Ascent at Fitzsimmons, find contemporary studio apartments in Aurora, CO that cater to your every need. Nestled in the vibrant community of North Aurora Division, our studio units offer thoughtfully designed spaces that maximize comfort and efficiency, ideal for your modern lifestyle.\n\nOur community doesn't just stop at providing great living spaces; enjoy extensive amenities like a playground, BBQ picnic area, and a newly renovated clubhouse. These features, along with select unit upgrades like granite countertops and vinyl flooring, deliver a balanced lifestyle that's perfect for any resident. Be part of a vibrant community where convenience at Ascent at Fitzsimmons is only steps away.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Aurora, CO",
      "seo_description": "Discover studio apartments at Ascent at Fitzsimmons in Aurora, CO, offering modern design and convenient amenities. Perfect for your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-north-aurora",
      "search_query": "one bedroom apartments North Aurora",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in North Aurora",
      "h2_subtitle": "Discover comfortable one bedroom apartments in North Aurora at Ascent at Fitzsimmons. Ideal blend of style and convenience awaits you.",
      "page_copy": "Experience the best of North Aurora living at Ascent at Fitzsimmons. Our one bedroom apartments in North Aurora provide spacious, tastefully appointed living areas. Ideal for anyone wanting a practical yet stylish home, these units offer a welcoming community feel.\n\nAs part of a vibrant neighborhood, residents enjoy onsite amenities such as a well-equipped playground, a relaxing BBQ picnic area, and a renovated clubhouse/leasing office. Choose our one bedroom apartments at Ascent at Fitzsimmons for unparalleled living in Aurora, CO. Whether it's the upgraded finishes in select units or the thoughtfully designed common areas, our community meets all your needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in North Aurora",
      "seo_description": "Find one bedroom apartments at Ascent at Fitzsimmons in North Aurora. Enjoy style, comfort, and great amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-colorado-anschutz-aurora",
      "search_query": "apartments near university of colorado anschutz aurora",
      "category": "School",
      "h1_title": "Apartments Near University of Colorado Anschutz",
      "h2_subtitle": "Explore convenient apartments near University of Colorado Anschutz in Aurora. Perfect for students and staff alike at Ascent at Fitzsimmons.",
      "page_copy": "Located just a short distance from the University of Colorado Anschutz Medical Campus, Ascent at Fitzsimmons offers prime apartments ideal for students, faculty, and staff. Enjoy a stress-free commute and vibrant living within our community that caters to modern lifestyles.\n\nOur apartments feature thoughtfully designed units with options like granite countertops in select apartments and amenities including a playground, BBQ picnic area, and a fully renovated clubhouse. Living near the University of Colorado Anschutz in Aurora means more than just proximity; it means enjoying the perfect combination of convenience, comfort, and community spirit at Ascent at Fitzsimmons.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Colorado Anschutz",
      "seo_description": "Discover apartments near University of Colorado Anschutz at Ascent at Fitzsimmons, Aurora. Enjoy an easy commute and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-hospital-colorado-anschutz",
      "search_query": "apartments near Children's Hospital Colorado Anschutz Medical Campus Aurora",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Hospital Colorado",
      "h2_subtitle": "Find quality apartments near Children's Hospital Colorado Anschutz Medical Campus in Aurora. Convenience and comfort at Ascent at Fitzsimmons.",
      "page_copy": "Situated close to the Children's Hospital Colorado Anschutz Medical Campus, Ascent at Fitzsimmons provides ideal living spaces for healthcare professionals and families. Our community offers a tranquil environment coupled with modern amenities, ensuring a balanced lifestyle while remaining conveniently near work.\n\nResidents enjoy access to community features like a fully renovated clubhouse, a playground, and a BBQ picnic area. Apartments feature options such as vinyl flooring and granite countertops in select units, combining comfort with style. Experience the ease of living near Children's Hospital Colorado Anschutz Medical Campus without compromising on quality or convenience when you choose Ascent at Fitzsimmons.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Hospital Colorado Anschutz",
      "seo_description": "Live near Children's Hospital Colorado Anschutz in Aurora. Enjoy convenience and community at Ascent at Fitzsimmons.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-uchealth-university-colorado-hospital",
      "search_query": "apartments near UCHealth University of Colorado Hospital Adams County",
      "category": "Hospital",
      "h1_title": "Apartments Near UCHealth University Hospital",
      "h2_subtitle": "Discover apartments near UCHealth University of Colorado Hospital in Adams County. Perfect blend of accessibility and serene living at Ascent at Fitzsimmons.",
      "page_copy": "Ascent at Fitzsimmons offers the perfect home base for those seeking apartments near UCHealth University of Colorado Hospital. Located in Adams County, our community provides a convenient haven for hospital employees and frequent visitors, offering a mix of modern amenities and peaceful surroundings.\n\nEnjoy on-site features such as a renovated clubhouse, a refreshing BBQ picnic area, and safe playgrounds, ensuring relaxation and recreation. Select units boast luxurious granite countertops, while all residents benefit from the overall comfort and ease of living that comes from being strategically positioned near UCHealth University of Colorado Hospital in Adams County. Make Ascent at Fitzsimmons your choice for convenience and community life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UCHealth University Hospital",
      "seo_description": "Live near UCHealth University of Colorado Hospital in Adams County. Enjoy comfort and convenience at Ascent at Fitzsimmons.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-denver-botanic-gardens",
      "search_query": "apartments near Denver Botanic Gardens CO",
      "category": "Park",
      "h1_title": "Apartments Near Denver Botanic Gardens",
      "h2_subtitle": "Experience life near Denver Botanic Gardens with our charming apartments. Discover the blend of nature and comfort at Ascent at Fitzsimmons.",
      "page_copy": "Nestled within a commutable distance to the enchanting Denver Botanic Gardens, Ascent at Fitzsimmons offers an excellent living option for those who cherish accessibility to nature and urban convenience. Our apartments are thoughtfully designed to provide comfort while being surrounded by the vibrant community of Aurora, Colorado.\n\nOur residents enjoy features like a playground and a BBQ picnic area, perfect for casual gatherings. The renovated clubhouse adds a touch of style to community living, while select units are enhanced with elegant granite countertops. Ascent at Fitzsimmons is more than just a place to live; it's a gateway to experiencing the cultural and natural delights near the Denver Botanic Gardens, offering both serenity and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Denver Botanic Gardens",
      "seo_description": "Live near Denver Botanic Gardens in Colorado with Ascent at Fitzsimmons. Enjoy an inviting community and easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-close-to-aurora-sports-park",
      "search_query": "apartments close to Aurora Sports Park North Aurora",
      "category": "Park",
      "h1_title": "Apartments Close to Aurora Sports Park",
      "h2_subtitle": "Live close to Aurora Sports Park in North Aurora. Discover the balance of active life and relaxation at Ascent at Fitzsimmons.",
      "page_copy": "Ascent at Fitzsimmons offers an ideal location for those looking to be close to the action at Aurora Sports Park in North Aurora. Perfect for sports enthusiasts and families, our community provides a blend of relaxation and activity with modern living spaces and outdoor amenities.\n\nThe community features a playground for kids and a BBQ picnic area perfect for weekend gatherings. Inside select units, you'll find luxurious granite countertops and durable vinyl flooring. Choose Ascent at Fitzsimmons to stay near the excitement of Aurora Sports Park while enjoying the comfort of a welcoming home in North Aurora.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Aurora Sports Park",
      "seo_description": "Find apartments near Aurora Sports Park in North Aurora at Ascent at Fitzsimmons. Enjoy active living and modern comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-by-four-mile-historic-park",
      "search_query": "apartments by Four Mile Historic Park Adams County",
      "category": "Park",
      "h1_title": "Apartments by Four Mile Historic Park",
      "h2_subtitle": "Explore apartments close to Four Mile Historic Park in Adams County. Enjoy a blend of history and comfort at Ascent at Fitzsimmons.",
      "page_copy": "Situated within reach of the charming Four Mile Historic Park, Ascent at Fitzsimmons offers an excellent living option for history buffs and those who enjoy cultural exploration. Located in the heart of Adams County, our community provides convenience and style for all its residents.\n\nEnjoy a variety of amenities including a spacious BBQ picnic area and a playground that offers outdoor enjoyment. Select units in our community are enhanced with chic granite countertops, while all residents benefit from the close proximity to the rich history and greenery of Four Mile Historic Park. Make Ascent at Fitzsimmons your home base for experiencing historical charm and modern living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Four Mile Historic Park",
      "seo_description": "Live near Four Mile Historic Park in Adams County. Experience the perfect mix of history and modern living at Ascent at Fitzsimmons.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-florida-station-aurora",
      "search_query": "apartments near Florida Station Aurora CO",
      "category": "Transit",
      "h1_title": "Apartments Near Florida Station Aurora",
      "h2_subtitle": "Discover our prime location near Florida Station in Aurora, CO. Enjoy seamless connectivity at Ascent at Fitzsimmons.",
      "page_copy": "Experience the convenience of living at Ascent at Fitzsimmons, located just a short distance from Florida Station in Aurora, CO. Our community is perfect for those who value quick access to public transportation, offering a seamless connection to the wider Denver area.\n\nResidents at Ascent at Fitzsimmons enjoy a range of amenities, from a playful playground to a versatile BBQ picnic area, ideal for friendly gatherings. Some of our units also feature beautiful granite countertops, providing a touch of luxury. Choose Ascent at Fitzsimmons for a lifestyle that combines modern comforts with effortless commuting options near Florida Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Florida Station Aurora",
      "seo_description": "Find your perfect home near Florida Station in Aurora, CO with Ascent at Fitzsimmons. Enjoy the benefits of easy commutes and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-close-to-fitzsimons-station",
      "search_query": "apartments close to Fitzsimons Station Adams County",
      "category": "Transit",
      "h1_title": "Apartments Close to Fitzsimons Station",
      "h2_subtitle": "Find convenience near Fitzsimons Station in Adams County. Explore modern living at Ascent at Fitzsimmons.",
      "page_copy": "Living at Ascent at Fitzsimmons offers the perfect blend of connectivity and comfort, with its prime location near Fitzsimons Station in Adams County. This makes commuting easy and efficient, providing access to the bustling surroundings and beyond.\n\nOur vibrant community features inviting amenities such as a BBQ picnic area, where residents can enjoy outdoor dining, and a playground for family-friendly fun. Select units are graced with granite countertops and modern vinyl flooring, ensuring style and functionality. With its proximity to Fitzsimons Station, Ascent at Fitzsimmons is your ideal choice for convenient and contemporary apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Fitzsimons Station",
      "seo_description": "Live close to Fitzsimons Station in Adams County at Ascent at Fitzsimmons. Enjoy the ease of modern living and excellent connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449167487",
      "source": "generator",
      "page_item_url": "apartments-near-13th-ave-station-north-aurora",
      "search_query": "apartments near 13th Ave Station North Aurora Division",
      "category": "Transit",
      "h1_title": "Apartments Near 13th Ave Station Aurora",
      "h2_subtitle": "Explore Ascent at Fitzsimmons, located near 13th Ave Station in the North Aurora Division. Enjoy a strategic location and modern amenities.",
      "page_copy": "Nestled in the North Aurora Division, Ascent at Fitzsimmons offers residents a prime location near the convenient 13th Ave Station. This strategic setting provides easy access to public transit, making daily commutes and urban explorations hassle-free.\n\nOur community prides itself on offering a variety of attractive amenities, including a recently renovated clubhouse and leasing office, a scenic BBQ picnic area, and a playful playground. Some apartments feature stylish granite countertops and sleek vinyl flooring, adding a touch of elegance to your home. Choose Ascent at Fitzsimmons for an ideal blend of accessibility and contemporary living near 13th Ave Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near 13th Ave Station Aurora",
      "seo_description": "Discover Ascent at Fitzsimmons, close to 13th Ave Station in North Aurora. Enjoy modern amenities and a prime location for convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11981734896"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NZT8JFXD"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "1191AFTZ"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "54896201129"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "ER100107678"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImQ3STkzQ1BRT3piV2xCcld5cGRXT0E9PSIsInZhbHVlIjoiRks1ZC9OVmMvMzNZc1lobXVmUWVnUT09IiwibWFjIjoiMTRiN2U0OWQ3MTk5NGMyZWViNTg2MGRhMDliYzc0MTM0NWI1ZmVjZjYxMzk1YjMxNTFkMWJlNmJiYzJjMGM5ZCJ9"
    }
  ],
  "custom_repli_id": "11981734896",
  "custom_google_gtm_id": "GTM-NZT8JFXD",
  "custom_rollout_phase": "Phase 3",
  "custom_vibesites_theme": "Preferred",
  "custom_aim_property_code": "1191AFTZ",
  "custom_hubspot_company_id": "54896201129",
  "custom_broker_license_number": "ER100107678",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImQ3STkzQ1BRT3piV2xCcld5cGRXT0E9PSIsInZhbHVlIjoiRks1ZC9OVmMvMzNZc1lobXVmUWVnUT09IiwibWFjIjoiMTRiN2U0OWQ3MTk5NGMyZWViNTg2MGRhMDliYzc0MTM0NWI1ZmVjZjYxMzk1YjMxNTFkMWJlNmJiYzJjMGM5ZCJ9",
  "custom_audioeye_site_id": "cf1fe8d4-47fa-4d48-9382-ca736ba61ba3",
  "custom_audioeye_site_hash": "9046935bb6f86861296fa861369bcbc8"
};

export const generatedAt = '2026-10-05T17:24:31.055Z';
